import React, { useEffect, useState, useContext, useMemo, useRef } from 'react';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import {
    Box, Typography, Button, Paper, Dialog, DialogTitle, DialogContent, DialogActions, TextField, IconButton, Divider, Snackbar, Alert, Select, MenuItem, FormControl, InputLabel, Autocomplete, Menu, InputAdornment, Radio, RadioGroup, FormControlLabel,
    useTheme, useMediaQuery, Fab, SwipeableDrawer, Checkbox, Avatar, Grid, Card, Slide, FormGroup, Switch, Popover,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, List, ListItem, ListItemIcon, ListItemText
} from '@mui/material';

import { DataGrid, GridToolbarContainer } from '@mui/x-data-grid';

import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import GetAppIcon from '@mui/icons-material/GetApp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import HistoryIcon from '@mui/icons-material/History';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import UndoIcon from '@mui/icons-material/Undo';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import AddIcon from '@mui/icons-material/Add';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import ShareIcon from '@mui/icons-material/Share';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import DensityMediumIcon from '@mui/icons-material/DensityMedium';
import DensitySmallIcon from '@mui/icons-material/DensitySmall';
import DensityLargeIcon from '@mui/icons-material/DensityLarge';
import FilterListIcon from '@mui/icons-material/FilterList';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// 🔥 Native Fast Custom Checkbox Component (With Transparent Background)
const CustomCheckbox = ({ checked, indeterminate, onChange, isDarkBg }) => {
    return (
        <div
            onClick={(e) => {
                e.stopPropagation();
                onChange({ target: { checked: !checked } });
            }}
            style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                width: '16px', height: '16px', cursor: 'pointer',
                border: isDarkBg ? '1.5px solid white' : '1.5px solid #204f4f',
                backgroundColor: checked ? (isDarkBg ? 'white' : '#204f4f') : 'transparent',
                borderRadius: '3px', margin: 'auto'
            }}
        >
            {checked && (
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={isDarkBg ? '#204f4f' : 'white'} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
            )}
            {indeterminate && !checked && (
                <div style={{ width: '8px', height: '2px', backgroundColor: isDarkBg ? 'white' : '#204f4f' }} />
            )}
        </div>
    );
};

const dropdownMenuProps = {
    PaperProps: {
        sx: {
            bgcolor: '#ffffff !important',
            backgroundColor: '#ffffff !important',
            backgroundImage: 'none !important',
            backdropFilter: 'none !important',
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
            '& .MuiMenuItem-root:hover': { color: '#000000 !important' },
            '& .MuiMenuItem-root.Mui-selected:hover': { color: '#000000 !important' },
            '& .MuiMenuItem-root.Mui-selected': { color: '#000000 !important' }
        }
    }
};

const autocompleteListboxProps = {
    sx: {
        '& .MuiAutocomplete-option:hover': { color: '#000000 !important' },
        '& .MuiAutocomplete-option[aria-selected="true"]': { color: '#000000 !important' },
        '& .MuiAutocomplete-option[aria-selected="true"]:hover': { color: '#000000 !important' },
    }
};

const toTitleCase = (str) => {
    if (!str) return "";
    return str.replace(/\w\S*/g, (t) => t.charAt(0).toUpperCase() + t.substr(1).toLowerCase());
};

const formatDate = (dStr) => {
    if (!dStr || dStr === '-') return '-';
    return dStr.split('-').reverse().join('-');
};

const formatDateTime = (isoString) => {
    if (!isoString) return '-';
    try {
        const dt = new Date(isoString);
        if (isNaN(dt.getTime())) return isoString;
        const d = String(dt.getDate()).padStart(2, '0');
        const m = String(dt.getMonth() + 1).padStart(2, '0');
        const y = dt.getFullYear();
        let hr = dt.getHours();
        const min = String(dt.getMinutes()).padStart(2, '0');
        const ampm = hr >= 12 ? 'PM' : 'AM';
        hr = hr % 12 || 12;
        const strHr = String(hr).padStart(2, '0');
        return `${d}-${m}-${y} ${strHr}:${min} ${ampm}`;
    } catch { return isoString; }
};

const formatSchemeName = (name) => {
    if (!name || name === '-') return '-';
    let cleanName = name.replace(/\s*\(.*?\)/g, '').replace(/\s*-\s*.*$/g, '').trim();
    let formattedName = cleanName.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
    const exceptionsList = ['LIC', 'JM', 'ICICI', 'HSBC', 'HDFC', 'DSP', 'BNP', 'ASK', '360 ONE', 'IIFL', 'IDFC', 'ITI', 'NJ', 'PGIM', 'PPFAS', 'SBI', 'UTI'];
    const exceptionsRegex = new RegExp(`\\b(${exceptionsList.join('|')})\\b`, 'gi');
    return formattedName.replace(exceptionsRegex, match => match.toUpperCase());
};

const StatusChip = ({ status }) => {
    const colorMap = {
        'Success': { color: '#2e7d32', bg: '#e8f5e9' },
        'Failed': { color: '#d32f2f', bg: '#ffebee' },
        'Skipped': { color: '#ed6c02', bg: '#fff3e0' },
        'Reordered': { color: '#1976d2', bg: '#e3f2fd' },
        'Reminded': { color: '#9c27b0', bg: '#f3e5f5' },
        'Pending': { color: '#616161', bg: '#f5f5f5' },
    };
    const c = colorMap[status] || colorMap['Pending'];
    return (
        <Box sx={{ bgcolor: c.bg, color: c.color, px: 1.5, py: 0.5, borderRadius: '6px', fontWeight: 'bold', fontSize: '0.8rem', display: 'inline-block' }}>
            {status}
        </Box>
    );
};

const menuPaperProps = {
    PaperProps: {
        sx: {
            bgcolor: '#ffffff !important', backgroundColor: '#ffffff !important', backgroundImage: 'none !important', backdropFilter: 'none !important',
            mt: 0.5, borderRadius: 2, boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
            '& .MuiList-root': { p: 1 },
            '& .MuiMenuItem-root:hover': { color: '#000000 !important' },
            '& .MuiMenuItem-root.Mui-selected:hover': { color: '#000000 !important' },
            '& .MuiMenuItem-root.Mui-selected': { color: '#000000 !important' }
        }
    }
};

const getMenuChipStyle = (color, bg) => ({
    color: color, bgcolor: bg, mb: 0.5, borderRadius: 1.5, fontSize: '0.85rem', fontWeight: 'bold', justifyContent: 'center',
    '&:hover': { bgcolor: bg, filter: 'brightness(0.95)' }, '&.Mui-selected': { bgcolor: bg, filter: 'brightness(0.9)', color: color }, '&.Mui-selected:hover': { bgcolor: bg, filter: 'brightness(0.85)', color: color }
});

function HistoryToolbar(props) {
    const { search, setSearch } = props;
    return (
        <GridToolbarContainer sx={{ p: 1.5, borderBottom: '1px solid rgba(224, 224, 224, 0.5)', bgcolor: 'rgba(255, 255, 255, 0.3)', display: 'flex', justifyContent: 'flex-end' }}>
            <TextField size="small" placeholder="Search Client or Scheme..." variant="standard" defaultValue={search} onChange={(e) => { if (window.histDeskTimer) clearTimeout(window.histDeskTimer); window.histDeskTimer = setTimeout(() => setSearch(e.target.value), 350); }} autoComplete="off" spellCheck="false" InputProps={{ startAdornment: (<InputAdornment position="start"><SearchIcon sx={{ color: '#204f4f', mr: 0.5 }} /></InputAdornment>) }} sx={{ width: '400px', transition: 'width 0.3s ease' }} />
        </GridToolbarContainer>
    );
}

const SipReminder = () => {
    const { user } = useContext(AuthContext);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const p = user?.permissions || {};
    const isOwner = user?.role === 'System Owner';

    const hasSipFilterStatus = isOwner || p.sipFilterStatus;
    const hasSipFilterUrgency = isOwner || p.sipFilterUrgency;
    const hasSipAdd = isOwner || p.sipAddSip;
    const hasSipStatus = isOwner || p.sipStatus;
    const hasSipActionCol = isOwner || p.sipActionCol;
    const hasSipLogCol = isOwner || p.sipLogCol;
    const hasSipEditCol = isOwner || p.sipEditCol;
    const hasSipUndo = isOwner || p.sipUndo;
    const hasSipAddNote = isOwner || p.sipAddNote;
    const hasSipProcess = isOwner || p.sipActionProcess;
    const hasSipDownload = isOwner || p.sipActionDownload;
    const hasSipUpload = isOwner || p.sipActionUpload;
    const hasSipExport = isOwner || p.sipActionExport;
    const hasSipViewHistory = isOwner || p.sipActionViewHistory;
    const hasSipExportHistory = isOwner || p.sipActionExportHistory;
    const hasSipReportWa = isOwner || p.sipReportWa;
    const hasSipReportPdf = isOwner || p.sipReportPdf;
    const canDelete = isOwner || p.sipActionDelete;

    const hasAnyAction = hasSipProcess || hasSipDownload || hasSipUpload || hasSipExport || hasSipViewHistory || hasSipExportHistory || canDelete;
    const hasAnyReport = hasSipReportWa || hasSipReportPdf;

    const token = localStorage.getItem('token');
    const apiConfig = useMemo(() => ({ headers: { Authorization: `Bearer ${token}` } }), [token]);

    const [data, setData] = useState([]);
    const [regClients, setRegClients] = useState([]);
    const [masterFunds, setMasterFunds] = useState([]);
    const [openManualDialog, setOpenManualDialog] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, msg: '', type: 'info' });
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectionMode, setSelectionMode] = useState(false);
    const [mobileDetailClient, setMobileDetailClient] = useState(null);
    const [rowMenuAnchor, setRowMenuAnchor] = useState(null);

    const [globalAnchorEl, setGlobalAnchorEl] = useState(null);

    const [globalSearch, setGlobalSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState("All");
    const [urgencyFilter, setUrgencyFilter] = useState("All");

    const [hiddenColumns, setHiddenColumns] = useState([]);
    const [colAnchorEl, setColAnchorEl] = useState(null);
    const [colSearch, setColSearch] = useState('');

    const [densityAnchorEl, setDensityAnchorEl] = useState(null);
    const [tableDensity, setTableDensity] = useState('compact');

    const [bulkStatusDialog, setBulkStatusDialog] = useState({ open: false, status: 'Reminded' });

    // 🔥 States for Database syncing
    const [isSettingsLoaded, setIsSettingsLoaded] = useState(false);
    const [frozenUntil, setFrozenUntil] = useState(null);
    const [colWidths, setColWidths] = useState({});
    const [colOrder, setColOrder] = useState([]);

    const baseColumns = useMemo(() => [
        { field: 'checkbox_col', headerName: '', defaultWidth: 60, resizable: false, align: 'center' },
        { field: 'whatsapp', headerName: 'WA', defaultWidth: 80, resizable: false, align: 'center' },
        { field: 'clientCode', headerName: 'Client Code', defaultWidth: 120 },
        { field: 'clientName', headerName: 'Client Name', defaultWidth: 180 },
        { field: 'mobileNumber', headerName: 'Mobile', defaultWidth: 140 },
        { field: 'mobileComment', headerName: 'Mobile Note', defaultWidth: 120 },
        { field: 'company', headerName: 'Company', defaultWidth: 110 },
        { field: 'bankName', headerName: 'Bank', defaultWidth: 140 },
        { field: 'category', headerName: 'Category', defaultWidth: 130 },
        { field: 'subCategory', headerName: 'Sub Category', defaultWidth: 170 },
        { field: 'schemeName', headerName: 'Scheme Name', defaultWidth: 280 },
        { field: 'amount', headerName: 'Amount', defaultWidth: 110 },
        { field: 'sipDate', headerName: 'Date', defaultWidth: 90, align: 'center' },
        { field: 'nextDate', headerName: 'Next SIP Date', defaultWidth: 120 },
        { field: 'status', headerName: 'Status', defaultWidth: 160 },
        { field: 'confirm', headerName: 'Action', defaultWidth: 100, align: 'center' },
        ...(hasSipLogCol ? [{ field: 'historyLog', headerName: 'Log', defaultWidth: 90, align: 'center' }] : []),
        ...(hasSipEditCol ? [{ field: 'editAction', headerName: 'Edit', defaultWidth: 90, align: 'center' }] : [])
    ], [hasSipLogCol, hasSipEditCol]);

    const [hoveredCol, setHoveredCol] = useState(null);
    const [resizing, setResizing] = useState(null);

    const [headerMenuAnchorEl, setHeaderMenuAnchorEl] = useState(null);
    const [activeHeaderMenuCol, setActiveHeaderMenuCol] = useState(null);
    const [activeHeaderElement, setActiveHeaderElement] = useState(null);

    const [filterAnchorEl, setFilterAnchorEl] = useState(null);
    const [colFilters, setColFilters] = useState({});
    const [currentFilter, setCurrentFilter] = useState({ field: '', operator: 'contains', value: '' });

    const [editDialog, setEditDialog] = useState({
        open: false, clientCode: '', oldSchemeName: '', oldSipDate: '', amount: '', sipDate: '', bankName: '', mobileNumber: '', company: ''
    });

    const [historyDialog, setHistoryDialog] = useState({ open: false, list: [] });
    const [allHistoryLogs, setAllHistoryLogs] = useState([]);
    const [historySearch, setHistorySearch] = useState("");

    const [singleHistoryDialog, setSingleHistoryDialog] = useState({
        open: false, clientCode: '', clientName: '', sipDate: '', name: '', history: []
    });

    const [processCycleDialog, setProcessCycleDialog] = useState(false);
    const [undoDialog, setUndoDialog] = useState({
        open: false, clientCode: '', schemeName: '', sipDate: ''
    });

    const [uploadDialog, setUploadDialog] = useState(false);
    const [uploadFile, setUploadFile] = useState(null);
    const [uploadStrategy, setUploadStrategy] = useState('accumulate');

    const [waDialog, setWaDialog] = useState({ open: false, phone: '', msg: '' });
    const [commentDialog, setCommentDialog] = useState({
        open: false, clientCode: '', schemeName: '', sipDate: '', currentComment: ''
    });

    const [clientInfo, setClientInfo] = useState({
        clientCode: '', clientName: '', mobileNumber: '', company: 'Angel One'
    });

    const [investments, setInvestments] = useState([{
        sipDate: '', category: '', subCategory: '', schemeName: '', amount: '', bankName: ''
    }]);

    const [deleteConfirmDialog, setDeleteConfirmDialog] = useState(false);
    const [pdfActionData, setPdfActionData] = useState(null);
    const [groupedPdfData, setGroupedPdfData] = useState([]);

    const fetchHistoryBackground = async () => {
        try {
            const res = await axios.get('/api/sip/history', apiConfig);
            setAllHistoryLogs(res.data || []);
        } catch (e) { console.error("History pre-fetch failed", e); }
    };

    useEffect(() => {
        fetchData();
        fetchMasterFunds();
        fetchHistoryBackground();
    }, [apiConfig]);

    const fetchData = async () => {
        try {
            const res = await axios.get('/api/sip', apiConfig);
            setData(res.data || []);
            const resReg = await axios.get('/api/scheme', apiConfig);
            setRegClients(resReg.data || []);
            fetchHistoryBackground();
        } catch (e) {
            console.error(e);
        }
    };

    const fetchMasterFunds = async () => {
        try {
            const res = await axios.get('/api/funds', apiConfig);
            setMasterFunds(res.data.funds || []);
        } catch (e) {
            console.error(e);
        }
    };

    const handleCodeChange = (newCode) => {
        const code = newCode.toUpperCase();
        const matchedClient = regClients.find(c => c.clientCode === code);

        if (matchedClient) {
            setClientInfo({
                clientCode: code,
                clientName: toTitleCase(matchedClient.clientName),
                mobileNumber: matchedClient.mobileNumber || '',
                company: matchedClient.company || 'Angel One'
            });
        } else {
            setClientInfo((prev) => ({ ...prev, clientCode: code, clientName: '', mobileNumber: '', company: 'Angel One' }));
        }
    };

    const categories = useMemo(() => [...new Set(masterFunds.map(f => f.category))].filter(Boolean), [masterFunds]);
    const getSubCat = (cat) => [...new Set(masterFunds.filter(f => f.category === cat).map(f => f.subCategory))].filter(Boolean).sort();
    const getSch = (cat, subCat) => masterFunds.filter(f => f.category === cat && f.subCategory === subCat).map(f => f.name).sort();

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    let pending5Days = 0;
    let pending2Days = 0;
    let totalReminded = 0;

    const allRows = useMemo(() => {
        return (data || []).flatMap((client, cIdx) => {
            return (client.investments || []).map((inv, iIdx) => {
                const nextD = new Date(inv.nextDate || new Date());
                nextD.setHours(0, 0, 0, 0);

                const diffDays = Math.ceil((nextD.getTime() - today.getTime()) / 86400000);
                const currentStatus = inv.status || 'Pending';

                if (currentStatus === 'Pending') {
                    if (diffDays >= 0 && diffDays <= 5) pending5Days++;
                    if (diffDays >= 0 && diffDays <= 2) pending2Days++;
                }
                if (currentStatus === 'Reminded') totalReminded++;

                return { ...client, ...inv, status: currentStatus, id: `sip_${client.clientCode}_${cIdx}_${iIdx}`, diffDays };
            });
        });
    }, [data, today]);

    const uniqueBanks = useMemo(() => [...new Set(allRows.map(r => r.bankName).filter(b => b && b.trim() !== '' && b.trim() !== '-'))].sort(), [allRows]);

    const filteredRows = useMemo(() => {
        let result = allRows.filter(r => {
            const term = globalSearch.toLowerCase();
            const matchSearch = !globalSearch || (r.clientName || "").toLowerCase().includes(term) || (r.clientCode || "").toLowerCase().includes(term) || (r.schemeName || "").toLowerCase().includes(term) || (r.category || "").toLowerCase().includes(term) || (r.subCategory || "").toLowerCase().includes(term) || (r.bankName || "").toLowerCase().includes(term);
            const matchStatus = statusFilter === 'All' || r.status === statusFilter;
            let matchUrgency = true;
            if (urgencyFilter !== 'All') {
                const isPendingAction = r.status === 'Pending' || r.status === 'Reminded';
                if (urgencyFilter === 'Overdue') matchUrgency = r.diffDays < 0 && isPendingAction;
                else if (urgencyFilter === '5 Days') matchUrgency = r.diffDays >= 0 && r.diffDays <= 5 && isPendingAction;
                else if (urgencyFilter === '2 Days') matchUrgency = r.diffDays >= 0 && r.diffDays <= 2 && isPendingAction;
            }
            return matchSearch && matchStatus && matchUrgency;
        });

        Object.keys(colFilters).forEach(field => {
            const filter = colFilters[field];
            if (!filter || (!filter.value && !['is empty', 'is not empty'].includes(filter.operator))) return;

            result = result.filter(r => {
                const cellValue = String(r[field] || '').toLowerCase();
                const filterVal = String(filter.value || '').toLowerCase();

                switch (filter.operator) {
                    case 'contains': return cellValue.includes(filterVal);
                    case 'equals': return cellValue === filterVal;
                    case 'starts with': return cellValue.startsWith(filterVal);
                    case 'ends with': return cellValue.endsWith(filterVal);
                    case 'is empty': return cellValue === '' || cellValue === '-';
                    case 'is not empty': return cellValue !== '' && cellValue !== '-';
                    default: return true;
                }
            });
        });

        return result.sort((a, b) => {
            if (a.clientName !== b.clientName) return (a.clientName || '').localeCompare(b.clientName || '');
            if (a.schemeName !== b.schemeName) return (a.schemeName || '').localeCompare(b.schemeName || '');
            if (a.sipDate !== b.sipDate) return parseInt(a.sipDate || 0) - parseInt(b.sipDate || 0);
            return (a.id || '').localeCompare(b.id || '');
        });
    }, [allRows, globalSearch, statusFilter, urgencyFilter, colFilters]);

    const rows = useMemo(() => {
        const uniqueClientNames = [...new Set(filteredRows.map(r => r.clientName))];
        return filteredRows.map((row) => {
            const nameIndex = uniqueClientNames.indexOf(row.clientName);
            const currentGroupColor = nameIndex % 2 === 0 ? 'even-row' : 'odd-row';
            return { ...row, rowClass: currentGroupColor };
        });
    }, [filteredRows]);

    const filteredHistoryRows = useMemo(() => {
        const baseFilteredHistory = historyDialog.list.filter(r => {
            const term = historySearch.toLowerCase();
            return ((r.clientName || "").toLowerCase().includes(term) || (r.clientCode || "").toLowerCase().includes(term) || (r.schemeName || "").toLowerCase().includes(term));
        });
        const uniqueHistoryClientNames = [...new Set(baseFilteredHistory.map(r => r.clientName))];
        let flatHistoryList = [];

        baseFilteredHistory.forEach((r) => {
            const nameIndex = uniqueHistoryClientNames.indexOf(r.clientName);
            const currentGroupColor = nameIndex % 2 === 0 ? 'even-row' : 'odd-row';

            flatHistoryList.push({
                ...r,
                latestLog: (r.history && r.history.length > 0) ? r.history[0] : null,
                internalId: `${r.clientCode}_${r.schemeName}_${r.sipDate}`,
                rowClass: currentGroupColor
            });
        });
        return flatHistoryList;
    }, [historyDialog.list, historySearch]);

    // 🔥 Initialize & Restore Settings from Database
    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const res = await axios.get('/api/sip/settings', apiConfig);
                const dbSettings = res.data.settings;

                let initialOrder = baseColumns.map(c => c.field);
                if (dbSettings && dbSettings.colOrder && dbSettings.colOrder.length === baseColumns.length) {
                    initialOrder = dbSettings.colOrder;
                } else {
                    const localOrder = JSON.parse(localStorage.getItem('sipColOrder'));
                    if (localOrder && localOrder.length === baseColumns.length) {
                        initialOrder = localOrder;
                    }
                }
                setColOrder(initialOrder);

                if (dbSettings && dbSettings.colWidths) {
                    setColWidths(dbSettings.colWidths);
                } else {
                    const localWidths = JSON.parse(localStorage.getItem('sipColWidths'));
                    if (localWidths) setColWidths(localWidths);
                }

                if (dbSettings && dbSettings.frozenUntil !== undefined) {
                    setFrozenUntil(dbSettings.frozenUntil);
                } else {
                    setFrozenUntil(localStorage.getItem('sipFrozenUntil') || null);
                }

                setIsSettingsLoaded(true);
            } catch (error) {
                setColOrder(baseColumns.map(c => c.field));
                setIsSettingsLoaded(true);
            }
        };
        fetchSettings();
    }, [apiConfig, baseColumns]);

    // Auto-calculate column widths if not set yet
    useEffect(() => {
        if (!isSettingsLoaded || allRows.length === 0) return;

        let updated = false;
        const newWidths = { ...colWidths };

        baseColumns.forEach(col => {
            if (!newWidths[col.field]) {
                let maxDataLen = 0;
                allRows.forEach(row => {
                    let val = row[col.field];
                    if (val !== null && val !== undefined) {
                        val = String(val);
                        if (val.length > maxDataLen) maxDataLen = val.length;
                    }
                });

                let headerPx = col.field === 'checkbox_col' ? 60 : (col.headerName.length * 12) + 75;
                let dataPx = col.field === 'checkbox_col' ? 60 : (maxDataLen * 9) + 40;

                let calcW = Math.max(headerPx, dataPx, col.defaultWidth);

                if (['whatsapp', 'confirm', 'historyLog', 'editAction'].includes(col.field)) calcW = col.defaultWidth;
                if (col.field === 'status') calcW = Math.max(calcW, 140);
                if (col.field === 'amount') calcW = Math.max(calcW, 110);

                newWidths[col.field] = calcW;
                updated = true;
            }
        });

        if (updated) {
            setColWidths(newWidths);
            triggerSaveSettings(newWidths, colOrder, frozenUntil);
        }
    }, [isSettingsLoaded, allRows, baseColumns, colWidths, colOrder, frozenUntil]);

    // Database Sync logic for Drag Resize & Move
    const saveToDBTimer = useRef(null);
    const triggerSaveSettings = (widths, order, frozen) => {
        if (saveToDBTimer.current) clearTimeout(saveToDBTimer.current);
        saveToDBTimer.current = setTimeout(async () => {
            try {
                await axios.post('/api/sip/settings', { settings: { colWidths: widths, colOrder: order, frozenUntil: frozen } }, apiConfig);
                localStorage.setItem('sipColWidths', JSON.stringify(widths));
                localStorage.setItem('sipColOrder', JSON.stringify(order));
                if (frozen) localStorage.setItem('sipFrozenUntil', frozen);
                else localStorage.removeItem('sipFrozenUntil');
            } catch (e) { }
        }, 1500);
    };

    // 🔥 Frozen Column Logic Calculation
    const frozenOffsets = useMemo(() => {
        const offsets = {};
        if (!frozenUntil) return offsets;

        let currentLeft = 0;
        let isFrozen = true;

        for (const field of colOrder) {
            if (hiddenColumns.includes(field)) continue;

            if (isFrozen) {
                offsets[field] = currentLeft;
                currentLeft += (colWidths[field] || baseColumns.find(c => c.field === field)?.defaultWidth || 100);
                if (field === frozenUntil) {
                    isFrozen = false;
                }
            }
        }
        return offsets;
    }, [colOrder, hiddenColumns, colWidths, frozenUntil, baseColumns]);

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (!resizing) return;
            const delta = e.clientX - resizing.startX;
            const newWidth = Math.max(50, resizing.startWidth + delta);
            setColWidths(prev => ({ ...prev, [resizing.field]: newWidth }));
        };
        const handleMouseUp = () => setResizing(null);

        if (resizing) {
            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);
        }
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, [resizing]);

    useEffect(() => {
        if (!resizing && Object.keys(colWidths).length > 0 && isSettingsLoaded) {
            triggerSaveSettings(colWidths, colOrder, frozenUntil);
        }
    }, [resizing]);

    const handleResizeStart = (e, field) => {
        e.preventDefault();
        e.stopPropagation();
        setResizing({ field, startX: e.clientX, startWidth: colWidths[field] });
    };

    const openHeaderMenu = (e, field) => {
        e.stopPropagation();
        setActiveHeaderMenuCol(field);
        setActiveHeaderElement(e.currentTarget);
        setHeaderMenuAnchorEl(e.currentTarget);
    };

    const resetColumnWidth = () => {
        if (activeHeaderMenuCol === 'checkbox_col') {
            setColWidths(prev => {
                const updated = { ...prev, ['checkbox_col']: 60 };
                triggerSaveSettings(updated, colOrder, frozenUntil);
                return updated;
            });
            setHeaderMenuAnchorEl(null);
            return;
        }

        const col = baseColumns.find(c => c.field === activeHeaderMenuCol);
        if (!col) return;

        let maxDataLen = 0;
        allRows.forEach(row => {
            let val = row[col.field];
            if (val != null) {
                val = String(val);
                if (val.length > maxDataLen) maxDataLen = val.length;
            }
        });

        let headerPx = col.headerName.length * 12 + 75;
        let dataPx = maxDataLen * 9 + 40;
        let calcW = Math.max(headerPx, dataPx, col.defaultWidth);

        if (['whatsapp', 'confirm', 'historyLog', 'editAction'].includes(col.field)) calcW = col.defaultWidth;
        if (col.field === 'status') calcW = Math.max(calcW, 140);

        setColWidths(prev => {
            const updated = { ...prev, [activeHeaderMenuCol]: calcW };
            triggerSaveSettings(updated, colOrder, frozenUntil);
            return updated;
        });
        setHeaderMenuAnchorEl(null);
    };

    const moveColumn = (direction) => {
        const visibleCols = colOrder.filter(c => !hiddenColumns.includes(c));
        const idx = visibleCols.indexOf(activeHeaderMenuCol);
        if ((direction === -1 && idx > 0) || (direction === 1 && idx < visibleCols.length - 1)) {
            const targetField = visibleCols[idx + direction];
            const realIdx1 = colOrder.indexOf(activeHeaderMenuCol);
            const realIdx2 = colOrder.indexOf(targetField);

            const newOrder = [...colOrder];
            [newOrder[realIdx1], newOrder[realIdx2]] = [newOrder[realIdx2], newOrder[realIdx1]];
            setColOrder(newOrder);
            triggerSaveSettings(colWidths, newOrder, frozenUntil);
        }
        setHeaderMenuAnchorEl(null);
    };

    const handleStatusUpdate = async (row, status) => {
        try {
            await axios.post('/api/sip/update-status', { clientCode: row.clientCode, schemeName: row.schemeName, sipDate: row.sipDate, status }, apiConfig);
            fetchData();
        } catch (e) { setSnackbar({ open: true, msg: 'Update Failed', type: 'error' }); }
    };

    // 🔥 Handle Bulk Status Update 
    const handleBulkStatusUpdate = async () => {
        const newStatus = bulkStatusDialog.status;
        const itemsToUpdate = rows.filter(r => selectedRows.includes(r.id)).map(r => ({
            clientCode: r.clientCode,
            schemeName: r.schemeName,
            sipDate: r.sipDate
        }));

        try {
            await axios.post('/api/sip/bulk-update-status', { items: itemsToUpdate, status: newStatus }, apiConfig);
            setSnackbar({ open: true, msg: `Status updated to ${newStatus} for ${itemsToUpdate.length} SIPs!`, type: 'success' });
            setBulkStatusDialog({ open: false, status: 'Reminded' });
            setSelectedRows([]);
            fetchData();
        } catch (e) {
            setSnackbar({ open: true, msg: 'Bulk Update Failed.', type: 'error' });
        }
    };

    // Helper logic for enabling/disabling complete options in Bulk Update based on Future date
    const canCompleteBulkSip = useMemo(() => {
        const itemsToUpdate = rows.filter(r => selectedRows.includes(r.id));
        if (itemsToUpdate.length === 0) return true;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        for (let row of itemsToUpdate) {
            const nextDt = new Date(row.nextDate || new Date());
            nextDt.setHours(0, 0, 0, 0);
            if (today < nextDt) return false;
        }
        return true;
    }, [rows, selectedRows]);

    const handleConfirmCycle = async (row) => {
        try {
            await axios.post('/api/sip/confirm-cycle', { clientCode: row.clientCode, schemeName: row.schemeName, sipDate: row.sipDate }, apiConfig);
            setSnackbar({ open: true, msg: 'SIP Logged and Moved to Next Month!', type: 'success' });
            fetchData();
            if (historyDialog.open) fetchAndOpenHistory();
        } catch (e) { setSnackbar({ open: true, msg: 'Failed', type: 'error' }); }
    };

    const triggerUndo = (clientCode, schemeName, sipDate) => {
        setUndoDialog({ open: true, clientCode, schemeName, sipDate });
    };

    const confirmUndoAction = async () => {
        try {
            await axios.post('/api/sip/revert-cycle', { clientCode: undoDialog.clientCode, schemeName: undoDialog.schemeName, sipDate: undoDialog.sipDate }, apiConfig);
            setSnackbar({ open: true, msg: 'Undo Successful! Cycle Reverted.', type: 'success' });
            setSingleHistoryDialog({ open: false, clientCode: '', sipDate: '', name: '', history: [] });
            setUndoDialog({ open: false, clientCode: '', schemeName: '', sipDate: '' });
            fetchData();
            if (historyDialog.open) fetchAndOpenHistory();
        } catch (e) { setSnackbar({ open: true, msg: 'Failed to Undo', type: 'error' }); }
    };

    const executeProcessCycle = async () => {
        const itemsToProcess = rows.filter(r => ['Success', 'Skipped', 'Reordered'].includes(r.status)).map(r => ({
            clientCode: r.clientCode,
            schemeName: r.schemeName,
            sipDate: r.sipDate
        }));

        if (itemsToProcess.length === 0) {
            setSnackbar({ open: true, msg: 'કોઈ SIP અપડેટ કરેલ નથી (Success/Skipped/Reordered).', type: 'warning' });
            setProcessCycleDialog(false);
            return;
        }

        try {
            const res = await axios.post('/api/sip/process-next-cycle', { items: itemsToProcess }, apiConfig);
            setSnackbar({ open: true, msg: res.data.message, type: 'success' });
            setProcessCycleDialog(false);
            setSelectedRows([]);
            fetchData();
            if (historyDialog.open) fetchAndOpenHistory();
        } catch (e) { setSnackbar({ open: true, msg: 'Failed to Process Cycle', type: 'error' }); }
    };

    const fetchAndOpenHistory = async () => {
        setGlobalAnchorEl(null);
        try {
            const res = await axios.get('/api/sip/history', apiConfig);
            setHistoryDialog({ open: true, list: res.data });
            setAllHistoryLogs(res.data);
        } catch (e) { console.error(e); }
    };

    const handleOpenSpecificHistory = (row) => {
        const match = allHistoryLogs.find(h =>
            h.clientCode === row.clientCode &&
            h.schemeName === row.schemeName &&
            parseInt(h.sipDate) === parseInt(row.sipDate)
        );

        if (match) {
            setSingleHistoryDialog({
                open: true,
                clientCode: match.clientCode,
                clientName: match.clientName || row.clientName,
                sipDate: match.sipDate,
                name: match.schemeName,
                history: match.history || []
            });
        } else {
            setSingleHistoryDialog({
                open: true,
                oldClientCode: row.clientCode,
                clientCode: row.clientCode,
                clientName: row.clientName || '',
                sipDate: row.sipDate,
                name: row.schemeName,
                history: []
            });
            setSnackbar({ open: true, msg: 'No history log found for this SIP yet.', type: 'info' });
        }
    };

    const handleBulkDelete = () => {
        setGlobalAnchorEl(null);
        if (selectedRows.length === 0) return setSnackbar({ open: true, msg: 'Please select at least one scheme to delete.', type: 'warning' });
        setDeleteConfirmDialog(true);
    };

    const executeBulkDelete = async () => {
        const items = rows.filter(r => selectedRows.includes(r.id)).map(r => ({ clientCode: r.clientCode, schemeName: r.schemeName, sipDate: r.sipDate }));
        try {
            await axios.post('api/sip/delete', { items }, apiConfig);
            setSnackbar({ open: true, msg: 'Deleted Successfully!', type: 'success' });
            setSelectedRows([]); fetchData();
        } catch (e) { setSnackbar({ open: true, msg: 'Delete Failed', type: 'error' }); }
        finally { setDeleteConfirmDialog(false); }
    };

    const menuAction = async (url) => {
        setGlobalAnchorEl(null);
        try {
            const apiUrl = url.startsWith('/') ? url : `/${url}`;
            const response = await axios.get(apiUrl, { ...apiConfig, responseType: 'blob' });
            const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = blobUrl;
            let fileName = 'SIP_Data.xlsx';
            if (url.includes('template')) fileName = 'SIP_Template.xlsx';
            else if (url.includes('export-history')) fileName = 'SIP_History_Export.xlsx';
            else if (url.includes('export')) fileName = 'Mahargh_SIP_Reminders.xlsx';
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            setSnackbar({ open: true, msg: 'File Downloaded Successfully!', type: 'success' });
        } catch (error) { setSnackbar({ open: true, msg: 'Failed to download file.', type: 'error' }); }
    };

    const handleExportHistory = async () => {
        try {
            const response = await axios.get('/api/sip/export-history', { ...apiConfig, responseType: 'blob' });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a'); link.href = url; link.setAttribute('download', 'SIP_History.xlsx');
            document.body.appendChild(link); link.click(); link.parentNode.removeChild(link);
        } catch (error) { setSnackbar({ open: true, msg: 'Failed to export history.', type: 'error' }); }
    };

    const handleFileSelect = (e) => {
        setGlobalAnchorEl(null);
        const file = e.target.files[0];
        if (!file) return;
        setUploadFile(file);
        setUploadDialog(true);
        e.target.value = null;
    };

    const handleHistoryUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const formData = new FormData();
        formData.append('file', file);
        try {
            await axios.post('/api/sip/upload-history', formData, { ...apiConfig, headers: { ...apiConfig.headers, 'Content-Type': 'multipart/form-data' } });
            setSnackbar({ open: true, msg: 'History Uploaded Successfully!', type: 'success' });
            fetchData();
            if (historyDialog.open) fetchAndOpenHistory();
        } catch (err) { setSnackbar({ open: true, msg: 'History Upload Failed', type: 'error' }); }
        e.target.value = null;
    };

    const handleConfirmUpload = async () => {
        if (!uploadFile) return;
        const formData = new FormData();
        formData.append('file', uploadFile);
        formData.append('strategy', uploadStrategy);
        try {
            await axios.post('api/sip/upload', formData, { ...apiConfig, headers: { ...apiConfig.headers, 'Content-Type': 'multipart/form-data' } });
            setSnackbar({ open: true, msg: 'Uploaded Successfully!', type: 'success' });
            fetchData(); setUploadDialog(false);
        } catch (err) { setSnackbar({ open: true, msg: 'Upload Failed', type: 'error' }); }
    };

    const handleOpenWhatsApp = async (overrideData = null) => {
        setGlobalAnchorEl(null); setRowMenuAnchor(null);
        const selectedData = overrideData || rows.filter(r => selectedRows.includes(r.id));
        if (selectedData.length === 0) return setSnackbar({ open: true, msg: 'Select at least one client SIP to share.', type: 'warning' });

        const uniqueClientsInSelection = [...new Set(selectedData.map(r => r.clientCode))];
        if (uniqueClientsInSelection.length > 1) return setSnackbar({ open: true, msg: 'Please select SIPs of only ONE client for WhatsApp.', type: 'warning' });

        const fullClientData = data.find(c => c.clientCode === uniqueClientsInSelection[0]);
        const clientToMsg = {
            ...fullClientData,
            investments: fullClientData.investments.filter(inv => selectedData.some(sd => sd.schemeName === inv.schemeName && sd.sipDate === inv.sipDate))
        };

        try {
            const res = await axios.post('api/sip/generate-wa', { selectedData: clientToMsg }, apiConfig);
            setWaDialog({ open: true, phone: res.data.phone, msg: res.data.msg });
        } catch (err) { setSnackbar({ open: true, msg: 'Failed to generate WhatsApp message', type: 'error' }); }
    };

    const handleDownloadPDF = async (overrideData = null) => {
        setGlobalAnchorEl(null);
        setRowMenuAnchor(null);

        const selectedData = overrideData || rows.filter(r => selectedRows.includes(r.id));
        if (selectedData.length === 0) return;

        const grouped = selectedData.reduce((acc, row) => {
            if (!acc[row.clientCode]) {
                acc[row.clientCode] = {
                    clientInfo: {
                        clientCode: row.clientCode,
                        clientName: row.clientName,
                        mobileNumber: row.mobileNumber,
                        company: row.company,
                        bankName: row.bankName
                    },
                    rows: [],
                    sipTotal: 0
                };
            }
            acc[row.clientCode].rows.push(row);
            acc[row.clientCode].sipTotal += parseFloat(row.amount || 0);
            return acc;
        }, {});

        const groupedArray = Object.values(grouped);
        setGroupedPdfData(groupedArray);

        setTimeout(async () => {
            try {
                const wrapperElement = document.getElementById('pdf-export-wrapper');
                if (wrapperElement) wrapperElement.style.display = 'block';

                const pdf = new jsPDF('p', 'mm', 'a4');
                const pages = document.getElementsByClassName('pdf-page-container');

                for (let i = 0; i < pages.length; i++) {
                    const canvas = await html2canvas(pages[i], { scale: 3, useCORS: true, logging: false, backgroundColor: '#ffffff' });
                    const imgData = canvas.toDataURL('image/png', 1.0);
                    const pdfWidth = pdf.internal.pageSize.getWidth();
                    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
                    if (i > 0) pdf.addPage();
                    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight, undefined, 'FAST');
                }

                const firstClientName = groupedArray[0]?.clientInfo?.clientName || 'Client';
                const fileName = `SIP Book - ${firstClientName}.pdf`;

                setPdfActionData({ blob: pdf.output('blob'), fileName });
                if (wrapperElement) wrapperElement.style.display = 'none';
            } catch (e) {
                console.error(e);
                setSnackbar({ open: true, msg: 'Failed to Generate PDF', type: 'error' });
            }
        }, 800);
    };

    const handleAddRow = () => {
        setInvestments([...investments, { sipDate: '', category: '', subCategory: '', schemeName: '', amount: '', bankName: '' }]);
    };

    const handleRemoveRow = (index) => {
        setInvestments(investments.filter((_, i) => i !== index));
    };

    const handleInvChange = (idx, field, value) => {
        const newInv = [...investments];
        newInv[idx][field] = value;
        if (field === 'category') { newInv[idx].subCategory = ''; newInv[idx].schemeName = ''; }
        if (field === 'subCategory') { newInv[idx].schemeName = ''; }
        setInvestments(newInv);
    };

    const handleSaveManual = async () => {
        const invs = investments.filter(i => i.schemeName && i.amount && i.sipDate);
        if (invs.length === 0) return setSnackbar({ open: true, msg: 'Please fill Scheme, SIP Date and Amount', type: 'warning' });

        try {
            await axios.post('api/sip/add', { clientCode: clientInfo.clientCode.toUpperCase(), clientName: toTitleCase(clientInfo.clientName), mobileNumber: clientInfo.mobileNumber, company: clientInfo.company, investments: invs }, apiConfig);
            setSnackbar({ open: true, msg: 'SIP Added Successfully!', type: 'success' });
            setOpenManualDialog(false);
            setClientInfo({ clientCode: '', clientName: '', mobileNumber: '', company: 'Angel One' });
            setInvestments([{ sipDate: '', category: '', subCategory: '', schemeName: '', amount: '', bankName: '' }]);
            fetchData();
        } catch (e) { setSnackbar({ open: true, msg: 'Failed to save', type: 'error' }); }
    };

    const handleSaveComment = async () => {
        try {
            await axios.post('api/sip/update-comment', { clientCode: commentDialog.clientCode, schemeName: commentDialog.schemeName, sipDate: commentDialog.sipDate, comment: commentDialog.currentComment }, apiConfig);
            setSnackbar({ open: true, msg: 'Comment saved successfully!', type: 'success' });
            setCommentDialog({ open: false, clientCode: '', schemeName: '', sipDate: '', currentComment: '' });
            fetchData();
        } catch (e) { setSnackbar({ open: true, msg: 'Failed to save comment.', type: 'error' }); }
    };

    // 🔥 Added default setup for Edit Dialog, similar to Add SIP
    const handleOpenEditDialog = (row) => {
        setEditDialog({
            open: true,
            oldClientCode: row.clientCode, // 🔥 નવું ઉમેર્યું
            clientCode: row.clientCode,
            clientName: row.clientName,
            oldSchemeName: row.schemeName,
            oldSipDate: row.sipDate,
            amount: row.amount,
            sipDate: row.sipDate,
            bankName: row.bankName || '',
            mobileNumber: row.mobileNumber || '',
            company: row.company || 'Angel One',
            category: row.category,
            subCategory: row.subCategory
        });
    };

    const handleSaveEdit = async () => {
        if (!editDialog.amount || !editDialog.sipDate || !editDialog.oldSchemeName || !editDialog.clientCode) return setSnackbar({ open: true, msg: 'Client Code, Scheme, Date, and Amount are required.', type: 'warning' });

        try {
            await axios.post('api/sip/edit', {
                oldClientCode: editDialog.oldClientCode, // 🔥 નવું ઉમેર્યું
                clientCode: editDialog.clientCode,       // 🔥 નવું ઉમેર્યું
                clientName: editDialog.clientName,       // 🔥 નવું ઉમેર્યું
                oldSchemeName: editDialog.oldSchemeName,
                oldSipDate: editDialog.oldSipDate,
                updatedAmount: editDialog.amount,
                updatedSipDate: editDialog.sipDate,
                updatedBankName: editDialog.bankName,
                updatedMobileNumber: editDialog.mobileNumber,
                updatedCompany: editDialog.company,
                updatedCategory: editDialog.category,
                updatedSubCategory: editDialog.subCategory
            }, apiConfig);

            setSnackbar({ open: true, msg: 'SIP Updated!', type: 'success' });
            setEditDialog({ open: false, clientCode: '', clientName: '', oldClientCode: '', oldSchemeName: '', oldSipDate: '', amount: '', sipDate: '', bankName: '', mobileNumber: '', company: '' });
            fetchData();
        } catch (e) { setSnackbar({ open: true, msg: 'Update Failed', type: 'error' }); }
    };

    const openFilter = () => {
        const existing = colFilters[activeHeaderMenuCol] || { operator: 'contains', value: '' };
        setCurrentFilter({ field: activeHeaderMenuCol, ...existing });
        setFilterAnchorEl(activeHeaderElement);
        setHeaderMenuAnchorEl(null);
    };

    const applyFilter = () => {
        if (currentFilter.value || ['is empty', 'is not empty'].includes(currentFilter.operator)) {
            setColFilters(prev => ({ ...prev, [currentFilter.field]: { operator: currentFilter.operator, value: currentFilter.value } }));
        } else {
            const newF = { ...colFilters };
            delete newF[currentFilter.field];
            setColFilters(newF);
        }
        setFilterAnchorEl(null);
    };

    const clearFilter = (fieldToClear) => {
        const newF = { ...colFilters };
        delete newF[fieldToClear || currentFilter.field];
        setColFilters(newF);
        setFilterAnchorEl(null);
    };

    const handleColumnsClick = (event) => setColAnchorEl(event.currentTarget);
    const handleColumnsClose = () => setColAnchorEl(null);

    const toggleColumn = (field) => {
        if (hiddenColumns.includes(field)) {
            setHiddenColumns(hiddenColumns.filter(c => c !== field));
        } else {
            setHiddenColumns([...hiddenColumns, field]);
        }
    };

    const handleHideAll = () => setHiddenColumns(baseColumns.filter(c => c.field !== 'mobileComment').map(c => c.field));
    const handleShowAll = () => setHiddenColumns([]);

    const filteredCols = baseColumns.filter(c => c.field !== 'mobileComment' && c.headerName.toLowerCase().includes(colSearch.toLowerCase()));

    const handleDensityClick = (event) => setDensityAnchorEl(event.currentTarget);
    const handleDensityClose = () => setDensityAnchorEl(null);
    const handleDensityChange = (density) => {
        setTableDensity(density);
        handleDensityClose();
    };

    const getDensityPadding = () => {
        if (tableDensity === 'compact') return '1px 12px';
        if (tableDensity === 'standard') return '12px 16px';
        if (tableDensity === 'comfortable') return '20px 16px';
        return '1px 12px';
    };

    const renderCellContent = (col, row) => {
        if (col.field === 'whatsapp') {
            return hasSipReportWa ? (<IconButton size="small" onClick={(e) => { e.stopPropagation(); handleOpenWhatsApp([row]); }} sx={{ color: '#075E54' }}><WhatsAppIcon fontSize="small" /></IconButton>) : null;
        }
        if (col.field === 'clientCode') return <strong style={{ color: '#204f4f' }}>{row.clientCode}</strong>;
        if (col.field === 'mobileNumber') {
            return (
                <Box onContextMenu={(e) => { e.preventDefault(); e.stopPropagation(); if (hasSipAddNote) { setCommentDialog({ open: true, clientCode: row.clientCode, schemeName: '', sipDate: '', currentComment: row.mobileComment || '' }); } else { setSnackbar({ open: true, msg: 'તમને Mobile Note એડ કરવાની પરવાનગી નથી.', type: 'warning' }); } }} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%', height: '100%', cursor: 'context-menu', bgcolor: 'transparent' }} title="Right-click to add a mobile note">
                    <Typography variant="body2" sx={{ fontWeight: '500', color: '#333' }}>{row.mobileNumber}</Typography>
                    {row.mobileComment && <Typography variant="caption" sx={{ color: '#c4a161', fontSize: '0.75rem', lineHeight: 1, mt: 0.2, fontWeight: 'bold', bgcolor: 'transparent', p: 0 }}>({row.mobileComment})</Typography>}
                </Box>
            );
        }
        if (col.field === 'company') return <Typography variant="caption" sx={{ color: '#888', fontWeight: 'bold' }}>{row.company}</Typography>;
        if (col.field === 'bankName') return <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#555' }}>{row.bankName}</Typography>;
        if (col.field === 'schemeName') return <Box sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontWeight: 500, width: '100%' }}>{formatSchemeName(row.schemeName)}</Box>;
        if (col.field === 'amount') return <span style={{ fontWeight: 'bold', color: '#204f4f' }}>₹{row.amount}</span>;
        if (col.field === 'sipDate') return <strong style={{ color: '#004d40' }}>{row.sipDate}</strong>;
        if (col.field === 'nextDate') return <strong style={{ color: '#204f4f' }}>{formatDate(row.nextDate)}</strong>;
        if (col.field === 'status') {
            const status = row.status || 'Pending';
            const today = new Date(); today.setHours(0, 0, 0, 0);
            const nextDt = new Date(row.nextDate || new Date()); nextDt.setHours(0, 0, 0, 0);
            const isFuture = today < nextDt;
            const colorMap = { 'Success': { color: '#2e7d32', bg: '#e8f5e9' }, 'Failed': { color: '#d32f2f', bg: '#ffebee' }, 'Skipped': { color: '#ed6c02', bg: '#fff3e0' }, 'Reordered': { color: '#1976d2', bg: '#e3f2fd' }, 'Reminded': { color: '#9c27b0', bg: '#f3e5f5' }, 'Pending': { color: '#616161', bg: '#f5f5f5' } };
            const currentColors = colorMap[status] || colorMap['Pending'];
            return (
                <Select size="small" value={status} fullWidth onClick={(e) => e.stopPropagation()} disabled={!hasSipStatus} onChange={(e) => handleStatusUpdate(row, e.target.value)} MenuProps={dropdownMenuProps} sx={{ height: 32, fontSize: '0.85rem', fontWeight: 'bold', color: currentColors.color, backgroundColor: currentColors.bg, '& .MuiOutlinedInput-notchedOutline': { border: '1px solid #dcdcdc' }, '&:hover': { backgroundColor: currentColors.bg }, '& .MuiSvgIcon-root': { color: currentColors.color }, '& .MuiSelect-select': { display: 'flex', alignItems: 'center', pr: '32px !important' } }}>
                    <MenuItem value="Pending"><Box display="flex" alignItems="center"><PendingActionsIcon fontSize="small" sx={{ mr: 1, color: '#616161' }} />Pending</Box></MenuItem>
                    <MenuItem value="Reminded"><Box display="flex" alignItems="center"><PendingActionsIcon fontSize="small" sx={{ mr: 1, color: '#9c27b0' }} />Reminded</Box></MenuItem>
                    <MenuItem value="Skipped"><Box display="flex" alignItems="center"><CancelIcon fontSize="small" sx={{ mr: 1, color: '#ed6c02' }} />Skipped</Box></MenuItem>
                    <MenuItem value="Success" disabled={isFuture} sx={{ color: isFuture ? 'grey' : '#2e7d32' }}><Box display="flex" alignItems="center"><CheckCircleIcon fontSize="small" sx={{ mr: 1, color: isFuture ? 'grey' : '#2e7d32' }} />Success</Box></MenuItem>
                    <MenuItem value="Failed" disabled={isFuture} sx={{ color: isFuture ? 'grey' : '#d32f2f' }}><Box display="flex" alignItems="center"><CancelIcon fontSize="small" sx={{ mr: 1, color: isFuture ? 'grey' : '#d32f2f' }} />Failed</Box></MenuItem>
                    <MenuItem value="Reordered" disabled={isFuture} sx={{ color: isFuture ? 'grey' : '#1976d2' }}><Box display="flex" alignItems="center"><CheckCircleIcon fontSize="small" sx={{ mr: 1, color: isFuture ? 'grey' : '#1976d2' }} />Reordered</Box></MenuItem>
                </Select>
            );
        }
        if (col.field === 'confirm') return (['Success', 'Reordered', 'Skipped'].includes(row.status) ? (<Tooltip title="Confirm & Move to Next Month"><IconButton size="small" disabled={!hasSipActionCol} sx={{ color: hasSipActionCol ? 'green' : 'grey' }} onClick={(e) => { e.stopPropagation(); handleConfirmCycle(row); }}><CheckCircleIcon fontSize="small" /></IconButton></Tooltip>) : null);
        if (col.field === 'historyLog') return (<Tooltip title="View History"><IconButton size="small" sx={{ color: '#1565c0' }} onClick={(e) => { e.stopPropagation(); handleOpenSpecificHistory(row); }}><HistoryIcon fontSize="small" /></IconButton></Tooltip>);
        if (col.field === 'editAction') return (<Tooltip title="Edit SIP"><IconButton size="small" sx={{ color: '#757575' }} onClick={(e) => { e.stopPropagation(); handleOpenEditDialog(row); }}><EditIcon fontSize="small" /></IconButton></Tooltip>);

        return row[col.field];
    };

    const historyColumns = [
        { field: 'clientCode', headerName: 'Client Code', flex: 1, minWidth: 120, renderCell: p => <strong style={{ color: '#204f4f' }}>{p.value}</strong> },
        { field: 'clientName', headerName: 'Client Name', flex: 1.5, minWidth: 180 },
        { field: 'schemeName', headerName: 'Scheme Name', flex: 2.5, minWidth: 280, renderCell: (p) => <Box sx={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: 1.4, py: 1, width: '100%' }}>{formatSchemeName(p.value)}</Box> },
        { field: 'latestCycle', headerName: 'Latest Cycle', width: 120, renderCell: p => { return p.row.latestLog ? p.row.latestLog.cycleMonth : '-' } },
        { field: 'executedOn', headerName: 'Executed On', width: 170, renderCell: p => { return p.row.latestLog ? formatDateTime(p.row.latestLog.executedOn) : '-' } },
        { field: 'amount', headerName: 'Amount', width: 100, renderCell: p => { return <strong style={{ color: '#204f4f' }}>₹{p.row.latestLog ? p.row.latestLog.amount : 0}</strong> } },
        { field: 'status', headerName: 'Status', width: 120, renderCell: p => { return <StatusChip status={p.row.latestLog ? p.row.latestLog.status : 'Unknown'} /> } },
        { field: 'actions', headerName: 'Full Log', width: 120, align: 'center', renderCell: p => (<Button size="small" variant="outlined" sx={{ color: '#757575', borderColor: '#c4c4c4', '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)', borderColor: '#757575' } }} onClick={() => setSingleHistoryDialog({ open: true, clientCode: p.row.clientCode, sipDate: p.row.sipDate, name: p.row.schemeName, history: p.row.history })}>View Log</Button>) }
    ];

    const singleHistoryColumns = [
        { field: 'cycleMonth', headerName: 'Cycle Month', flex: 1 },
        { field: 'executedOn', headerName: 'Executed On', flex: 1, renderCell: p => formatDateTime(p.value) },
        { field: 'amount', headerName: 'Amount', flex: 1, renderCell: p => <strong style={{ color: '#204f4f' }}>₹{p.value}</strong> },
        { field: 'status', headerName: 'Status', flex: 1, renderCell: p => <StatusChip status={p.value} /> },
        { field: 'undo', headerName: 'Undo Action', width: 120, align: 'center', renderCell: p => { if (p.row.isFirst) { return (<Tooltip title="Undo & Revert this cycle"><IconButton color={hasSipUndo ? "error" : "default"} size="small" disabled={!hasSipUndo} onClick={() => triggerUndo(singleHistoryDialog.clientCode, singleHistoryDialog.name, singleHistoryDialog.sipDate)}><UndoIcon fontSize="small" /></IconButton></Tooltip>); } return '-'; } }
    ];

    const singleHistoryRows = singleHistoryDialog.history.map((h, i) => ({ ...h, id: i, isFirst: i === 0 }));

    return (
        <Box sx={{ p: { xs: 1, md: 3 }, pb: { md: 1 }, bgcolor: 'transparent', position: 'relative', boxSizing: 'border-box', height: { xs: 'calc(100vh - 65px)', md: 'calc(100vh - 100px)' }, display: { xs: 'block', md: 'flex' }, flexDirection: { md: 'column' }, overflowY: { xs: 'auto', md: 'hidden' }, overflowX: 'hidden', '&::-webkit-scrollbar': { width: '2px', height: '2px' }, '&::-webkit-scrollbar-track': { background: 'transparent' }, '&::-webkit-scrollbar-thumb': { background: 'rgba(0,0,0,0.05)', borderRadius: '10px' }, '& *::-webkit-scrollbar': { width: '2px', height: '2px' }, '& *::-webkit-scrollbar-track': { background: 'transparent' }, '& *::-webkit-scrollbar-thumb': { background: 'rgba(0,0,0,0.05)', borderRadius: '10px' } }}>

            <Box sx={{ position: 'absolute', top: '-10000px', left: '-10000px', zIndex: -1 }} id="pdf-export-wrapper">
                {groupedPdfData.map((clientGroup, pageIndex) => {
                    const { clientInfo, rows: clientRows, sipTotal } = clientGroup;
                    return (
                        <Box key={clientInfo.clientCode} className="pdf-page-container" sx={{ bgcolor: 'white', width: '800px', fontFamily: 'sans-serif', mb: 5 }}>
                            <Box sx={{ pt: '35px', bgcolor: 'white', position: 'relative' }}>
                                <Box sx={{ position: 'absolute', top: 0, right: '45px', width: '135px', height: '125px', bgcolor: '#1c4542', borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10 }}>
                                    <img src={process.env.PUBLIC_URL + '/logopdf.png'} alt="Logo" style={{ width: '100px', height: 'auto' }} />
                                </Box>
                                <Box sx={{ bgcolor: '#f2eee6', display: 'flex', alignItems: 'center', px: 5, py: 2.5 }}>
                                    <Box display="flex" alignItems="center" gap={3} zIndex={2}>
                                        <img src={process.env.PUBLIC_URL + '/treepdf.png'} alt="Tree" style={{ height: '100px', objectFit: 'contain' }} />
                                        <Box textAlign="left" sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                            <Typography sx={{ fontSize: '22px', color: '#333', mb: 0, lineHeight: 1.1, fontFamily: "'Barlow', sans-serif" }}>Your Upcoming</Typography>
                                            <Typography sx={{ fontSize: '26px', fontWeight: 'bold', color: '#111', lineHeight: 1.1, mt: '2px', letterSpacing: '-0.3px', fontFamily: "'Barlow', sans-serif" }}>Systematic Investment Plan (SIP)</Typography>
                                            <Box sx={{ height: '1.5px', bgcolor: '#222', width: '100%', mt: '4px', mb: '4px' }} />
                                            <Typography sx={{ fontSize: '12px', color: '#444', fontStyle: 'italic', lineHeight: 1, fontFamily: "'Barlow', sans-serif" }}>“Consistent steps create wealth.”</Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                            <Box sx={{ p: 5 }}>
                                <TableContainer component={Paper} elevation={0} sx={{ mb: 3, border: '1px solid #e0e0e0', borderRadius: '6px', overflow: 'hidden' }}>
                                    <Box sx={{ background: 'linear-gradient(90deg, #2a5858 0%, #549090 100%)', py: 1, px: 2 }}><Typography sx={{ color: 'white', fontWeight: 'bold', fontSize: '15px' }}>Client Profile Details</Typography></Box>
                                    <Table size="small">
                                        <TableBody>
                                            <TableRow>
                                                <TableCell sx={{ bgcolor: '#f5f5f5', fontWeight: 'bold', width: '18%' }}>Client Name:</TableCell><TableCell sx={{ width: '32%' }}>{clientInfo.clientName}</TableCell>
                                                <TableCell sx={{ bgcolor: '#f5f5f5', fontWeight: 'bold', width: '25%' }}>Total Monthly SIP:</TableCell><TableCell sx={{ color: '#1b5e20', fontWeight: 'bold', width: '25%' }}>₹ {sipTotal.toLocaleString('en-IN')}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell sx={{ bgcolor: '#f5f5f5', fontWeight: 'bold' }}>Client ID:</TableCell><TableCell>{clientInfo.clientCode}</TableCell>
                                                <TableCell sx={{ bgcolor: '#f5f5f5', fontWeight: 'bold' }}>Bank Name:</TableCell><TableCell>{clientInfo.bankName || '-'}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell sx={{ bgcolor: '#f5f5f5', fontWeight: 'bold' }}>Mobile Number:</TableCell><TableCell>{clientInfo.mobileNumber}</TableCell>
                                                <TableCell sx={{ bgcolor: '#f5f5f5', fontWeight: 'bold' }}>Date:</TableCell><TableCell>{`${String(new Date().getDate()).padStart(2, '0')}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${new Date().getFullYear()}`}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #e0e0e0', borderRadius: '6px', overflow: 'hidden' }}>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow sx={{ background: 'linear-gradient(90deg, #2a5858 0%, #549090 100%)' }}>
                                                <TableCell sx={{ color: 'white', fontWeight: 'bold', width: '5%', fontSize: '13px' }}>Sr. No.</TableCell><TableCell sx={{ color: 'white', fontWeight: 'bold', width: '28%', fontSize: '13px' }}>Scheme Name</TableCell><TableCell sx={{ color: 'white', fontWeight: 'bold', width: '13%', fontSize: '13px' }}>Category</TableCell><TableCell sx={{ color: 'white', fontWeight: 'bold', width: '14%', fontSize: '13px' }}>Sub Category</TableCell><TableCell sx={{ color: 'white', fontWeight: 'bold', width: '11%', fontSize: '13px' }}>Bank</TableCell><TableCell sx={{ color: 'white', fontWeight: 'bold', width: '13%', fontSize: '13px' }}>Next SIP Date</TableCell><TableCell align="right" sx={{ color: 'white', fontWeight: 'bold', width: '16%', fontSize: '13px' }}>Amount</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {clientRows.map((row, index) => {
                                                let cleanName = formatSchemeName(row.schemeName);
                                                let smartSubCat = (row.subCategory || '-').replace(/\//g, '/ ');
                                                let smartBank = (row.bankName || '-').replace(/\s/g, '\n');
                                                return (
                                                    <TableRow key={index} sx={{ '&:nth-of-type(even)': { bgcolor: '#f9f9f9' } }}>
                                                        <TableCell sx={{ fontSize: '11px' }}>{index + 1}</TableCell>
                                                        <TableCell sx={{ fontSize: '11px', pr: 1, fontWeight: 'bold', whiteSpace: 'normal', lineHeight: 1.3 }}>{cleanName}</TableCell>
                                                        <TableCell sx={{ fontSize: '11px' }}>{row.category}</TableCell>
                                                        <TableCell sx={{ fontSize: '11px', whiteSpace: 'normal', lineHeight: 1.3, pr: 0.5 }}>{smartSubCat}</TableCell>
                                                        <TableCell sx={{ fontSize: '11px', whiteSpace: 'pre-line', lineHeight: 1.2 }}>{smartBank}</TableCell>
                                                        <TableCell sx={{ fontSize: '11px', color: '#004d40', fontWeight: 'bold' }}>{formatDate(row.nextDate)}</TableCell>
                                                        <TableCell align="right" sx={{ fontWeight: 'bold', fontSize: '11px', color: '#d32f2f' }}>₹ {parseFloat(row.amount || 0).toLocaleString('en-IN')}</TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                            <TableRow sx={{ bgcolor: '#fdfbf7' }}><TableCell colSpan={6} align="right" sx={{ fontWeight: 'bold', color: '#1c4542', fontSize: '14px' }}>Total SIP Amount</TableCell><TableCell align="right" sx={{ fontWeight: 'bold', color: '#1b5e20', fontSize: '15px' }}>₹ {sipTotal.toLocaleString('en-IN')}</TableCell></TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <Box sx={{ mt: 5, pt: 2, borderTop: '1px solid #eee', textAlign: 'center' }}><Typography variant="body2" sx={{ color: '#333' }}>Prepared by <strong>Mahargh Nivesh</strong> | Mutual Fund Distributor</Typography><Typography variant="caption" sx={{ display: 'block', mt: 1, color: '#c4a161', fontWeight: 'bold' }}>Mutual Fund investments are subject to market risks. Please read all scheme-related documents carefully.</Typography></Box>
                            </Box>
                        </Box>
                    );
                })}
            </Box>

            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <Box display="flex" justifyContent="space-between" alignItems="flex-end" mb={1.5}>
                    <Box>
                        <Typography variant="h4" gutterBottom sx={{ color: '#204f4f', fontWeight: 'bold' }}>Client SIP Reminders</Typography>
                        <Box display="flex" alignItems="center" gap={3} mt={1}>
                            <Typography variant="subtitle2" sx={{ color: '#8a6d3b', fontWeight: 'bold', letterSpacing: 1 }}>Mahargh Wealth OS</Typography>
                            <Divider orientation="vertical" flexItem sx={{ borderRightWidth: 2, borderColor: '#c4a161' }} />
                            <Box display="flex" alignItems="center" gap={0.5} sx={{ bgcolor: '#e3f2fd', px: 1.5, py: 0.5, borderRadius: 2, border: '1px solid #bbdefb' }}><AutorenewIcon sx={{ fontSize: 18, color: '#1565c0' }} /><Typography variant="body2" sx={{ fontWeight: 'bold', color: '#0d47a1' }}>Total SIPs: {allRows.length}</Typography></Box>
                            <Box display="flex" alignItems="center" gap={0.5} sx={{ bgcolor: '#efebe9', px: 1.5, py: 0.5, borderRadius: 2, border: '1px solid #d7ccc8' }}><Typography variant="body2" sx={{ fontWeight: 'bold', color: '#5d4037' }}>5 Days Pending : {pending5Days}</Typography></Box>
                            <Box display="flex" alignItems="center" gap={0.5} sx={{ bgcolor: '#e0f7fa', px: 1.5, py: 0.5, borderRadius: 2, border: '1px solid #b2ebf2' }}><Typography variant="body2" sx={{ fontWeight: 'bold', color: '#00838f' }}>2 Days Pending : {pending2Days}</Typography></Box>
                            <Box display="flex" alignItems="center" gap={0.5} sx={{ bgcolor: '#f3e5f5', px: 1.5, py: 0.5, borderRadius: 2, border: '1px solid #e1bee7' }}><Typography variant="body2" sx={{ fontWeight: 'bold', color: '#8e24aa' }}>Reminded : {totalReminded}</Typography></Box>
                        </Box>
                    </Box>
                </Box>
                <Divider sx={{ mb: 3, borderColor: '#e6c07e', borderBottomWidth: 2 }} />
            </Box>

            <Box sx={{ display: { xs: 'block', md: 'none' }, mb: 2 }}>
                <Typography variant="h5" fontWeight="bold" color="#204f4f">Client SIP Reminders</Typography>
                <Divider sx={{ mt: 0.5, mb: 1, borderColor: '#c4a161', borderBottomWidth: 2, width: '100%' }} />
                <Typography variant="subtitle2" sx={{ color: '#8a6d3b', fontWeight: 'bold', mb: 1.5, pl: 0.5, letterSpacing: 0.5 }}>Mahargh Wealth OS</Typography>
                <Box sx={{ display: 'flex', width: '100%', gap: 0.5, mb: 1.5, px: 0.5, overflowX: 'auto', '&::-webkit-scrollbar': { display: 'none' } }}>
                    <Box display="flex" alignItems="center" justifyContent="center" gap={0.5} sx={{ flex: 1, minWidth: 'max-content', bgcolor: '#e3f2fd', color: '#0d47a1', borderRadius: '5px', py: 0.8, px: 1, border: '1px solid #bbdefb' }}><AutorenewIcon sx={{ fontSize: '1.1rem' }} /><Typography sx={{ fontWeight: 'bold', fontSize: '0.75rem', whiteSpace: 'nowrap' }}>Total: {allRows.length}</Typography></Box>
                    <Box display="flex" alignItems="center" justifyContent="center" gap={0.5} sx={{ flex: 1, minWidth: 'max-content', bgcolor: '#efebe9', color: '#5d4037', borderRadius: '5px', py: 0.8, px: 1, border: '1px solid #d7ccc8' }}><Typography sx={{ fontWeight: 'bold', fontSize: '0.75rem', whiteSpace: 'nowrap' }}>5 Days: {pending5Days}</Typography></Box>
                    <Box display="flex" alignItems="center" justifyContent="center" gap={0.5} sx={{ flex: 1, minWidth: 'max-content', bgcolor: '#e0f7fa', color: '#00838f', borderRadius: '5px', py: 0.8, px: 1, border: '1px solid #b2ebf2' }}><Typography sx={{ fontWeight: 'bold', fontSize: '0.75rem', whiteSpace: 'nowrap' }}>2 Days: {pending2Days}</Typography></Box>
                    <Box display="flex" alignItems="center" justifyContent="center" gap={0.5} sx={{ flex: 1, minWidth: 'max-content', bgcolor: '#f3e5f5', color: '#8e24aa', borderRadius: '5px', py: 0.8, px: 1, border: '1px solid #e1bee7' }}><Typography sx={{ fontWeight: 'bold', fontSize: '0.75rem', whiteSpace: 'nowrap' }}>Reminded: {totalReminded}</Typography></Box>
                </Box>
                {/* 🔥 Mobile Selection Toggle & Select All */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1} px={0.5}>
                    <Box display="flex" alignItems="center">
                        <Switch size="small" checked={selectionMode} onChange={(e) => { setSelectionMode(e.target.checked); if (!e.target.checked) setSelectedRows([]); }} sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#204f4f' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#204f4f' } }} />
                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#204f4f', mr: 1 }}></Typography>
                        {selectionMode && rows.length > 0 && (
                            <Box display="flex" alignItems="center" ml={1} borderLeft="1px solid #ccc" pl={1}>
                                <Checkbox size="small" checked={selectedRows.length === rows.length} onChange={(e) => { if (e.target.checked) { setSelectedRows(rows.map(r => r.id)); } else { setSelectedRows([]); } }} sx={{ p: 0.5, color: '#c4a161', '&.Mui-checked': { color: '#204f4f' } }} />
                                <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#204f4f' }}>All</Typography>
                            </Box>
                        )}
                    </Box>
                </Box>
            </Box>

            {isMobile && (
                <Box sx={{ position: 'sticky', top: 0, zIndex: 1000, bgcolor: '#ffffff', pt: 1.5, pb: 1.5, mx: -1, px: 2, mb: 1, boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                    <TextField fullWidth size="small" placeholder="Search Client, Scheme, Bank..." variant="standard" defaultValue={globalSearch} onChange={(e) => { if (window.mobSearchTimer) clearTimeout(window.mobSearchTimer); window.mobSearchTimer = setTimeout(() => setGlobalSearch(e.target.value), 350); }} autoComplete="off" spellCheck="false" InputProps={{ startAdornment: (<InputAdornment position="start"><SearchIcon sx={{ color: '#204f4f', mr: 1 }} /></InputAdornment>) }} sx={{ mb: 1.5 }} />
                    <Box display="flex" gap={1}>
                        {hasSipFilterStatus && (
                            <FormControl size="small" fullWidth sx={{ bgcolor: 'white', borderRadius: 1 }}>
                                <Select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} displayEmpty MenuProps={menuPaperProps} sx={{ fontSize: '0.8rem', fontWeight: 'bold' }}>
                                    <MenuItem value="All" sx={getMenuChipStyle('#37474f', '#eceff1')}>All Status</MenuItem><MenuItem value="Pending" sx={getMenuChipStyle('#616161', '#f5f5f5')}>Pending</MenuItem><MenuItem value="Reminded" sx={getMenuChipStyle('#9c27b0', '#f3e5f5')}>Reminded</MenuItem><MenuItem value="Success" sx={getMenuChipStyle('#2e7d32', '#e8f5e9')}>Success</MenuItem><MenuItem value="Skipped" sx={getMenuChipStyle('#ed6c02', '#fff3e0')}>Skipped</MenuItem><MenuItem value="Failed" sx={getMenuChipStyle('#d32f2f', '#ffebee')}>Failed</MenuItem><MenuItem value="Reordered" sx={getMenuChipStyle('#1976d2', '#e3f2fd')}>Reordered</MenuItem>
                                </Select>
                            </FormControl>
                        )}
                        {hasSipFilterUrgency && (
                            <FormControl size="small" fullWidth sx={{ bgcolor: 'white', borderRadius: 1 }}>
                                <Select value={urgencyFilter} onChange={(e) => setUrgencyFilter(e.target.value)} displayEmpty MenuProps={menuPaperProps} sx={{ fontSize: '0.8rem', fontWeight: 'bold' }}>
                                    <MenuItem value="All" sx={getMenuChipStyle('#37474f', '#eceff1')}>All Time</MenuItem><MenuItem value="Overdue" sx={getMenuChipStyle('#880e4f', '#fce4ec')}>Overdue</MenuItem><MenuItem value="2 Days" sx={getMenuChipStyle('#00838f', '#e0f7fa')}>Upcoming (2 Days)</MenuItem><MenuItem value="5 Days" sx={getMenuChipStyle('#5d4037', '#efebe9')}>Upcoming (5 Days)</MenuItem>
                                </Select>
                            </FormControl>
                        )}
                    </Box>
                </Box>
            )}

            {/* 🔥 Floating Action Button for Mobile / Tablet */}
            {isMobile && (
                <Fab
                    aria-label="actions"
                    onClick={(e) => setGlobalAnchorEl(e.currentTarget)}
                    sx={{ position: 'fixed', bottom: 20, right: 20, bgcolor: '#204f4f', color: '#fff', '&:hover': { bgcolor: '#153333' }, zIndex: 1100 }}
                >
                    <AddIcon />
                </Fab>
            )}

            {/* 🔥 Main Actions Menu (Contains Everything!) */}
            <Menu anchorEl={globalAnchorEl} open={Boolean(globalAnchorEl)} onClose={() => setGlobalAnchorEl(null)} PaperProps={menuPaperProps}>
                {selectedRows.length > 0 && hasSipReportPdf && <MenuItem onClick={() => { handleDownloadPDF(null); setGlobalAnchorEl(null); }} sx={{ color: '#d32f2f', fontWeight: 'bold' }}><PictureAsPdfIcon sx={{ mr: 1.5 }} /> Share PDF ({selectedRows.length})</MenuItem>}
                {selectedRows.length > 0 && hasSipReportWa && <MenuItem onClick={() => { handleOpenWhatsApp(null); setGlobalAnchorEl(null); }} sx={{ color: '#075E54', fontWeight: 'bold' }}><WhatsAppIcon sx={{ mr: 1.5 }} /> Share via WhatsApp ({selectedRows.length})</MenuItem>}
                {selectedRows.length > 0 && hasSipStatus && <MenuItem onClick={() => { setBulkStatusDialog({ open: true, status: 'Reminded' }); setGlobalAnchorEl(null); }} sx={{ color: '#9c27b0', fontWeight: 'bold' }}><PendingActionsIcon sx={{ mr: 1.5 }} /> Update Bulk SIP Status ({selectedRows.length})</MenuItem>}
                {selectedRows.length > 0 && (hasSipReportPdf || hasSipReportWa || hasSipStatus) && <Divider />}

                {isMobile && hasSipAdd && <MenuItem onClick={() => { setOpenManualDialog(true); setGlobalAnchorEl(null); }} sx={{ color: '#204f4f', fontWeight: 'bold' }}><AddCircleIcon sx={{ mr: 1.5 }} /> Add SIP</MenuItem>}
                {isMobile && hasSipAdd && <Divider />}

                {hasSipProcess && <MenuItem onClick={() => { setGlobalAnchorEl(null); setProcessCycleDialog(true); }} sx={{ color: '#1b5e20', fontWeight: 'bold', bgcolor: '#e8f5e9', '&:hover': { bgcolor: '#c8e6c9' } }}><AutorenewIcon sx={{ mr: 1.5 }} /> Next Cycle</MenuItem>}
                {canDelete && <MenuItem onClick={handleBulkDelete} sx={{ color: '#c62828', fontWeight: 500, bgcolor: '#ffebee', '&:hover': { bgcolor: '#ffcdd2' } }}><DeleteIcon sx={{ mr: 1.5 }} /> Delete ({selectedRows.length})</MenuItem>}
                {(hasSipProcess || canDelete) && <Divider />}

                {hasSipDownload && <MenuItem onClick={() => menuAction('api/sip/template')} sx={{ color: '#204f4f', fontWeight: 500 }}><GetAppIcon sx={{ mr: 1.5 }} /> Template</MenuItem>}
                {hasSipUpload && <MenuItem component="label" sx={{ color: '#204f4f', fontWeight: 500 }}><CloudUploadIcon sx={{ mr: 1.5 }} /> Import<input type="file" hidden accept=".xlsx" onChange={(e) => { if (e.target.files[0]) { setUploadFile(e.target.files[0]); setUploadDialog(true); } setGlobalAnchorEl(null); e.target.value = null; }} /></MenuItem>}
                {(hasSipDownload || hasSipUpload) && <Divider />}

                {hasSipViewHistory && <MenuItem onClick={fetchAndOpenHistory} sx={{ color: '#1565c0', fontWeight: 500 }}><HistoryIcon sx={{ mr: 1.5 }} /> History</MenuItem>}
                {hasSipExportHistory && <MenuItem onClick={() => menuAction('api/sip/export-history')} sx={{ color: '#1565c0', fontWeight: 500 }}><CloudDownloadIcon sx={{ mr: 1.5 }} /> Export History</MenuItem>}
            </Menu>

            <Menu anchorEl={rowMenuAnchor?.el} open={Boolean(rowMenuAnchor)} onClose={() => setRowMenuAnchor(null)} PaperProps={menuPaperProps}>
                <MenuItem onClick={() => { setMobileDetailClient(rowMenuAnchor.row); setRowMenuAnchor(null); }} sx={{ fontWeight: 'bold', color: '#204f4f' }}>View Details</MenuItem>
                {hasSipReportPdf && <MenuItem onClick={() => { handleDownloadPDF([rowMenuAnchor.row]); setRowMenuAnchor(null); }} sx={{ fontWeight: 'bold', color: '#d32f2f' }}>Share PDF</MenuItem>}
                {hasSipReportWa && <MenuItem onClick={() => { handleOpenWhatsApp([rowMenuAnchor.row]); setRowMenuAnchor(null); }} sx={{ fontWeight: 'bold', color: '#128C7E' }}>Share via WhatsApp</MenuItem>}
            </Menu>

            {/* 🔥 Native Table View for Desktop */}
            {!isMobile ? (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flexGrow: 1, overflow: 'hidden' }}>
                    <Paper sx={{ width: '100%', flexGrow: 1, border: '1px solid #e0e0e0', borderRadius: 2, bgcolor: '#ffffff', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>

                        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>

                            {/* Toolbar */}
                            <Box sx={{ p: 1.5, borderBottom: '1px solid rgba(224, 224, 224, 0.5)', bgcolor: 'rgba(255, 255, 255, 0.3)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
                                <Box display="flex" gap="15px" alignItems="center" flexWrap="wrap">
                                    <Button size="small" startIcon={<ViewColumnIcon />} onClick={handleColumnsClick} sx={{ color: '#204f4f', fontWeight: 'bold', textTransform: 'none' }}>
                                        Columns
                                    </Button>

                                    <Popover
                                        open={Boolean(colAnchorEl)}
                                        anchorEl={colAnchorEl}
                                        onClose={handleColumnsClose}
                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                        PaperProps={{ sx: { width: 250, p: 2, borderRadius: 2, boxShadow: '0 4px 20px rgba(0,0,0,0.15)', bgcolor: '#ffffff', backgroundImage: 'none' } }}
                                    >
                                        <TextField
                                            size="small" fullWidth placeholder="Find column" variant="standard"
                                            value={colSearch} onChange={(e) => setColSearch(e.target.value)}
                                            sx={{ mb: 1 }}
                                        />
                                        <Box sx={{ maxHeight: 250, overflowY: 'auto', '&::-webkit-scrollbar': { width: '4px' }, '&::-webkit-scrollbar-thumb': { bgcolor: '#bdbdbd', borderRadius: '4px' } }}>
                                            <FormGroup>
                                                {filteredCols.map(col => (
                                                    <FormControlLabel
                                                        key={col.field}
                                                        control={<Switch size="small" checked={!hiddenColumns.includes(col.field)} onChange={() => toggleColumn(col.field)} sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#204f4f' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#204f4f' } }} />}
                                                        label={<Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>{col.headerName}</Typography>}
                                                        sx={{ ml: 0, '& .MuiFormControlLabel-label': { ml: 1 } }}
                                                    />
                                                ))}
                                            </FormGroup>
                                        </Box>
                                        <Box display="flex" justifyContent="space-between" mt={1} pt={1} borderTop="1px solid #eee">
                                            <Button size="small" onClick={handleHideAll} sx={{ textTransform: 'none', color: '#204f4f', fontWeight: 'bold' }}>Hide all</Button>
                                            <Button size="small" onClick={handleShowAll} sx={{ textTransform: 'none', color: '#204f4f', fontWeight: 'bold' }}>Show all</Button>
                                        </Box>
                                    </Popover>

                                    <Button size="small" startIcon={<DensityMediumIcon />} onClick={handleDensityClick} sx={{ color: '#204f4f', fontWeight: 'bold', textTransform: 'none' }}>
                                        Density
                                    </Button>

                                    <Popover
                                        open={Boolean(densityAnchorEl)}
                                        anchorEl={densityAnchorEl}
                                        onClose={handleDensityClose}
                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                        PaperProps={{ sx: { width: 160, borderRadius: 2, boxShadow: '0 4px 20px rgba(0,0,0,0.15)', bgcolor: '#ffffff', backgroundImage: 'none' } }}
                                    >
                                        <List disablePadding>
                                            <ListItem disablePadding>
                                                <Button fullWidth onClick={() => handleDensityChange('compact')} sx={{ justifyContent: 'flex-start', px: 2, py: 1, color: tableDensity === 'compact' ? '#204f4f' : '#555', bgcolor: tableDensity === 'compact' ? 'rgba(32, 79, 79, 0.08)' : 'transparent', textTransform: 'none' }}>
                                                    <ListItemIcon sx={{ minWidth: 36 }}><DensitySmallIcon fontSize="small" sx={{ color: tableDensity === 'compact' ? '#204f4f' : '#777' }} /></ListItemIcon>
                                                    <ListItemText primary={<Typography variant="body2" fontWeight={tableDensity === 'compact' ? 'bold' : 'normal'}>Compact</Typography>} />
                                                </Button>
                                            </ListItem>
                                            <ListItem disablePadding>
                                                <Button fullWidth onClick={() => handleDensityChange('standard')} sx={{ justifyContent: 'flex-start', px: 2, py: 1, color: tableDensity === 'standard' ? '#204f4f' : '#555', bgcolor: tableDensity === 'standard' ? 'rgba(32, 79, 79, 0.08)' : 'transparent', textTransform: 'none' }}>
                                                    <ListItemIcon sx={{ minWidth: 36 }}><DensityMediumIcon fontSize="small" sx={{ color: tableDensity === 'standard' ? '#204f4f' : '#777' }} /></ListItemIcon>
                                                    <ListItemText primary={<Typography variant="body2" fontWeight={tableDensity === 'standard' ? 'bold' : 'normal'}>Standard</Typography>} />
                                                </Button>
                                            </ListItem>
                                            <ListItem disablePadding>
                                                <Button fullWidth onClick={() => handleDensityChange('comfortable')} sx={{ justifyContent: 'flex-start', px: 2, py: 1, color: tableDensity === 'comfortable' ? '#204f4f' : '#555', bgcolor: tableDensity === 'comfortable' ? 'rgba(32, 79, 79, 0.08)' : 'transparent', textTransform: 'none' }}>
                                                    <ListItemIcon sx={{ minWidth: 36 }}><DensityLargeIcon fontSize="small" sx={{ color: tableDensity === 'comfortable' ? '#204f4f' : '#777' }} /></ListItemIcon>
                                                    <ListItemText primary={<Typography variant="body2" fontWeight={tableDensity === 'comfortable' ? 'bold' : 'normal'}>Comfortable</Typography>} />
                                                </Button>
                                            </ListItem>
                                        </List>
                                    </Popover>

                                    <Button size="small" startIcon={<GetAppIcon />} onClick={() => menuAction('api/sip/export')} sx={{ color: '#204f4f', fontWeight: 'bold', textTransform: 'none' }}>Export Excel</Button>
                                </Box>

                                <Box display="flex" gap="15px" alignItems="center" flexWrap="wrap">
                                    <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: '15px', alignItems: 'center' }}>
                                        {hasSipFilterStatus && (
                                            <FormControl size="small" sx={{ minWidth: 120 }}>
                                                <Select variant="standard" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} displayEmpty MenuProps={menuPaperProps} sx={{ fontSize: '0.85rem', fontWeight: 500, color: '#204f4f', pb: 0.5 }}>
                                                    <MenuItem value="All" sx={getMenuChipStyle('#37474f', '#eceff1')}>All Status</MenuItem>
                                                    <MenuItem value="Pending" sx={getMenuChipStyle('#616161', '#f5f5f5')}>Pending</MenuItem>
                                                    <MenuItem value="Reminded" sx={getMenuChipStyle('#9c27b0', '#f3e5f5')}>Reminded</MenuItem>
                                                    <MenuItem value="Success" sx={getMenuChipStyle('#2e7d32', '#e8f5e9')}>Success</MenuItem>
                                                    <MenuItem value="Skipped" sx={getMenuChipStyle('#ed6c02', '#fff3e0')}>Skipped</MenuItem>
                                                    <MenuItem value="Failed" sx={getMenuChipStyle('#d32f2f', '#ffebee')}>Failed</MenuItem>
                                                    <MenuItem value="Reordered" sx={getMenuChipStyle('#1976d2', '#e3f2fd')}>Reordered</MenuItem>
                                                </Select>
                                            </FormControl>
                                        )}

                                        {hasSipFilterUrgency && (
                                            <FormControl size="small" sx={{ minWidth: 120 }}>
                                                <Select variant="standard" value={urgencyFilter} onChange={(e) => setUrgencyFilter(e.target.value)} displayEmpty MenuProps={menuPaperProps} sx={{ fontSize: '0.85rem', fontWeight: 500, color: '#204f4f', pb: 0.5 }}>
                                                    <MenuItem value="All" sx={getMenuChipStyle('#37474f', '#eceff1')}>All Time</MenuItem>
                                                    <MenuItem value="Overdue" sx={getMenuChipStyle('#880e4f', '#fce4ec')}>Overdue</MenuItem>
                                                    <MenuItem value="2 Days" sx={getMenuChipStyle('#00838f', '#e0f7fa')}>Upcoming (2 Days)</MenuItem>
                                                    <MenuItem value="5 Days" sx={getMenuChipStyle('#5d4037', '#efebe9')}>Upcoming (5 Days)</MenuItem>
                                                </Select>
                                            </FormControl>
                                        )}

                                        <TextField size="small" placeholder="Search Client, Scheme..." variant="standard" defaultValue={globalSearch} onChange={(e) => { if (window.deskSearchTimer) clearTimeout(window.deskSearchTimer); window.deskSearchTimer = setTimeout(() => setGlobalSearch(e.target.value), 350); }} autoComplete="off" spellCheck="false" InputProps={{ startAdornment: (<InputAdornment position="start"><SearchIcon sx={{ color: '#204f4f', mr: 0.5 }} /></InputAdornment>) }} sx={{ width: '300px', transition: 'width 0.3s ease', ml: 1 }} />
                                    </Box>

                                    {/* 🔥 Actions Menu Button */}
                                    {(hasAnyAction || hasAnyReport || hasSipStatus) && <Button variant="outlined" onClick={(e) => setGlobalAnchorEl(e.currentTarget)} endIcon={<ArrowDropDownIcon />} sx={{ height: '36px', color: '#204f4f', border: '1px solid #e0e0e0', fontWeight: 'bold', textTransform: 'none', bgcolor: 'white' }}>Actions</Button>}

                                    {hasSipAdd && <Button variant="contained" startIcon={<AddCircleIcon />} onClick={() => setOpenManualDialog(true)} sx={{ height: '36px', bgcolor: '#204f4f', color: '#fff', fontWeight: 'bold', textTransform: 'none', '&:hover': { bgcolor: '#153333' } }}>Add SIP</Button>}
                                </Box>
                            </Box>

                            {/* Native Table */}
                            <TableContainer sx={{ flexGrow: 1, overflowY: 'auto', '&::-webkit-scrollbar': { width: '6px', height: '6px' }, '&::-webkit-scrollbar-thumb': { background: '#bdbdbd', borderRadius: '10px' } }}>
                                <Table stickyHeader size="small" sx={{ minWidth: 1400, tableLayout: 'fixed' }}>
                                    <TableHead>
                                        <TableRow>
                                            {colOrder.filter(f => f !== 'mobileComment' && !hiddenColumns.includes(f)).map((field) => {
                                                const col = baseColumns.find(c => c.field === field);
                                                if (!col) return null;
                                                const isHovered = hoveredCol === field;
                                                const isFrozen = frozenOffsets.hasOwnProperty(field);
                                                const leftOffset = isFrozen ? frozenOffsets[field] : 'auto';
                                                const isLastFrozen = field === frozenUntil;

                                                if (field === 'checkbox_col') {
                                                    return (
                                                        <TableCell
                                                            key={field}
                                                            onMouseEnter={() => setHoveredCol(field)}
                                                            onMouseLeave={() => setHoveredCol(null)}
                                                            padding="none"
                                                            align="center"
                                                            sx={{
                                                                bgcolor: isFrozen ? '#1a4343' : '#204f4f',
                                                                width: colWidths['checkbox_col'] || 60,
                                                                minWidth: colWidths['checkbox_col'] || 60,
                                                                maxWidth: colWidths['checkbox_col'] || 60,
                                                                zIndex: isFrozen ? 5 : 3,
                                                                position: isFrozen ? 'sticky' : 'relative',
                                                                top: 0,
                                                                left: leftOffset,
                                                                boxShadow: isLastFrozen ? '2px 0px 5px -2px rgba(0,0,0,0.5)' : 'none',
                                                                borderRight: isLastFrozen ? '1px solid #143636' : 'none',
                                                                p: 0
                                                            }}
                                                        >
                                                            <Box display="flex" alignItems="center" justifyContent="center" width="100%" sx={{ position: 'relative' }}>
                                                                <CustomCheckbox
                                                                    isDarkBg={true}
                                                                    checked={rows.length > 0 && selectedRows.length === rows.length}
                                                                    indeterminate={selectedRows.length > 0 && selectedRows.length < rows.length}
                                                                    onChange={(e) => {
                                                                        if (e.target.checked) setSelectedRows(rows.map(r => r.id));
                                                                        else setSelectedRows([]);
                                                                    }}
                                                                />
                                                                <Box display="flex" alignItems="center" sx={{ position: 'absolute', right: -4, opacity: isHovered || activeHeaderMenuCol === 'checkbox_col' ? 1 : 0, transition: 'opacity 0.2s', bgcolor: isFrozen ? '#1a4343' : '#204f4f', pl: 0.5 }}>
                                                                    <IconButton size="small" sx={{ color: 'white', p: 0.1 }} onClick={(e) => openHeaderMenu(e, 'checkbox_col')}>
                                                                        <MoreVertIcon fontSize="small" />
                                                                    </IconButton>
                                                                    <Box onMouseDown={(e) => handleResizeStart(e, 'checkbox_col')} sx={{ width: '1px', height: '20px', bgcolor: 'transparent', cursor: 'col-resize', ml: 0.5, '&:hover': { bgcolor: '#ffffff', width: '2px' }, ...(hoveredCol === 'checkbox_col' && { bgcolor: 'rgba(255,255,255,0.5)' }) }} />
                                                                </Box>
                                                            </Box>
                                                        </TableCell>
                                                    )
                                                }

                                                return (
                                                    <TableCell
                                                        key={field}
                                                        onMouseEnter={() => setHoveredCol(field)}
                                                        onMouseLeave={() => setHoveredCol(null)}
                                                        sx={{
                                                            bgcolor: isFrozen ? '#1a4343' : '#204f4f',
                                                            color: '#ffffff', fontSize: '0.85rem', fontWeight: 'bold',
                                                            whiteSpace: 'nowrap', width: colWidths[field] || col.defaultWidth, px: 2, py: 1.5,
                                                            position: 'sticky', top: 0,
                                                            left: leftOffset,
                                                            zIndex: isFrozen ? 5 : 3,
                                                            boxShadow: isLastFrozen ? '2px 0px 5px -2px rgba(0,0,0,0.5)' : 'none',
                                                            borderRight: isLastFrozen ? '1px solid #143636' : 'none'
                                                        }}
                                                    >
                                                        <Box display="flex" alignItems="center" justifyContent="space-between" width="100%" sx={{ position: 'relative' }}>
                                                            <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{col.headerName}</Box>

                                                            {/* Header Menu Icon (3 dots) + Divider visible on hover */}
                                                            <Box display="flex" alignItems="center" sx={{ position: 'absolute', right: -8, opacity: isHovered || activeHeaderMenuCol === field ? 1 : 0, transition: 'opacity 0.2s', bgcolor: isFrozen ? '#1a4343' : '#204f4f', pl: 0.5 }}>
                                                                <IconButton size="small" sx={{ color: 'white', p: 0.1 }} onClick={(e) => openHeaderMenu(e, field)}>
                                                                    <MoreVertIcon fontSize="small" />
                                                                </IconButton>
                                                                <Box
                                                                    onMouseDown={(e) => handleResizeStart(e, field)}
                                                                    sx={{
                                                                        width: '1px', height: '20px', bgcolor: 'transparent', cursor: 'col-resize', ml: 0.5,
                                                                        '&:hover': { bgcolor: '#ffffff', width: '2px' },
                                                                        ...(isHovered && { bgcolor: 'rgba(255,255,255,0.5)' })
                                                                    }}
                                                                />
                                                            </Box>
                                                        </Box>
                                                    </TableCell>
                                                )
                                            })}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows.map((row) => {
                                            const cellBgColor = row.rowClass === 'even-row' ? '#ffffff' : '#e9eff0';
                                            return (
                                                <TableRow key={row.id} hover sx={{ bgcolor: cellBgColor, '&:hover': { bgcolor: '#fdfbf7' } }}>
                                                    {colOrder.filter(f => f !== 'mobileComment' && !hiddenColumns.includes(f)).map((field) => {
                                                        const col = baseColumns.find(c => c.field === field);
                                                        if (!col) return null;

                                                        const isFrozen = frozenOffsets.hasOwnProperty(field);
                                                        const leftOffset = isFrozen ? frozenOffsets[field] : 'auto';
                                                        const isLastFrozen = field === frozenUntil;

                                                        if (field === 'checkbox_col') {
                                                            return (
                                                                <TableCell
                                                                    key={field}
                                                                    align="center"
                                                                    padding="none"
                                                                    sx={{
                                                                        width: colWidths['checkbox_col'] || 60,
                                                                        minWidth: colWidths['checkbox_col'] || 60,
                                                                        maxWidth: colWidths['checkbox_col'] || 60,
                                                                        borderBottom: '1px solid #e0e0e0', verticalAlign: 'middle',
                                                                        position: isFrozen ? 'sticky' : 'relative',
                                                                        left: leftOffset, zIndex: isFrozen ? 4 : 1,
                                                                        backgroundColor: cellBgColor,
                                                                        boxShadow: isLastFrozen ? '2px 0px 5px -2px rgba(0,0,0,0.2)' : 'none',
                                                                        borderRight: isLastFrozen ? '1px solid #e0e0e0' : 'none'
                                                                    }}
                                                                >
                                                                    <CustomCheckbox
                                                                        isDarkBg={false}
                                                                        checked={selectedRows.includes(row.id)}
                                                                        onChange={(e) => {
                                                                            if (e.target.checked) setSelectedRows([...selectedRows, row.id]);
                                                                            else setSelectedRows(selectedRows.filter(id => id !== row.id));
                                                                        }}
                                                                    />
                                                                </TableCell>
                                                            )
                                                        }

                                                        return (
                                                            <TableCell key={field} sx={{
                                                                fontSize: '0.85rem', padding: getDensityPadding(), borderBottom: '1px solid #e0e0e0',
                                                                verticalAlign: 'middle', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                                                                width: colWidths[field] || col.defaultWidth,
                                                                minWidth: colWidths[field] || col.defaultWidth,
                                                                maxWidth: colWidths[field] || col.defaultWidth,
                                                                position: isFrozen ? 'sticky' : 'relative',
                                                                left: leftOffset,
                                                                zIndex: isFrozen ? 4 : 1,
                                                                backgroundColor: cellBgColor,
                                                                boxShadow: isLastFrozen ? '2px 0px 5px -2px rgba(0,0,0,0.2)' : 'none',
                                                                borderRight: isLastFrozen ? '1px solid #e0e0e0' : 'none'
                                                            }}>
                                                                {renderCellContent(col, row)}
                                                            </TableCell>
                                                        )
                                                    })}
                                                </TableRow>
                                            )
                                        })}
                                        {rows.length === 0 && (
                                            <TableRow>
                                                <TableCell colSpan={colOrder.length + 1} align="center" sx={{ py: 3, color: 'text.secondary' }}>No records found</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            {/* 🔥 Header Context Menu (Reset Width, Filter, Reorder) */}
                            <Menu
                                anchorEl={headerMenuAnchorEl}
                                open={Boolean(headerMenuAnchorEl)}
                                onClose={() => setHeaderMenuAnchorEl(null)}
                                PaperProps={menuPaperProps}
                            >
                                <MenuItem onClick={resetColumnWidth} sx={{ fontSize: '0.85rem', color: '#333' }}>
                                    <SettingsBackupRestoreIcon fontSize="small" sx={{ mr: 1.5, color: '#666' }} /> Reset Width
                                </MenuItem>
                                {activeHeaderMenuCol !== 'checkbox_col' && (
                                    <MenuItem onClick={openFilter} sx={{ fontSize: '0.85rem', color: '#333' }}>
                                        <FilterListIcon fontSize="small" sx={{ mr: 1.5, color: '#666' }} /> Filter Column
                                    </MenuItem>
                                )}
                                <MenuItem onClick={() => { setFrozenUntil(frozenOffsets.hasOwnProperty(activeHeaderMenuCol) ? null : activeHeaderMenuCol); setHeaderMenuAnchorEl(null); }} sx={{ fontSize: '0.85rem', color: '#333' }}>
                                    <ViewColumnIcon fontSize="small" sx={{ mr: 1.5, color: '#666' }} /> {frozenOffsets.hasOwnProperty(activeHeaderMenuCol) ? 'Unfreeze Column' : 'Freeze up to here'}
                                </MenuItem>

                                {activeHeaderMenuCol !== 'checkbox_col' && (
                                    <Box>
                                        <Divider sx={{ my: 0.5 }} />
                                        <MenuItem onClick={() => moveColumn(-1)} sx={{ fontSize: '0.85rem', color: '#333' }}>
                                            <ArrowBackIosNewIcon fontSize="small" sx={{ mr: 1.5, color: '#666' }} /> Move Left
                                        </MenuItem>
                                        <MenuItem onClick={() => moveColumn(1)} sx={{ fontSize: '0.85rem', color: '#333' }}>
                                            <ArrowForwardIosIcon fontSize="small" sx={{ mr: 1.5, color: '#666' }} /> Move Right
                                        </MenuItem>
                                    </Box>
                                )}
                            </Menu>

                            {/* 🔥 Filter Popover for specific column */}
                            <Popover
                                open={Boolean(filterAnchorEl)}
                                anchorEl={filterAnchorEl}
                                onClose={() => setFilterAnchorEl(null)}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                sx={{ mt: 1 }} // Pushes it right below the header
                                PaperProps={{ sx: { width: 350, p: 2, borderRadius: 2, boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)', bgcolor: '#ffffff', backgroundImage: 'none' } }}
                            >
                                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                    <Typography variant="body2" fontWeight="bold" color="#204f4f">Filter: {baseColumns.find(c => c.field === currentFilter.field)?.headerName}</Typography>
                                    <IconButton size="small" onClick={() => clearFilter()}><CloseIcon fontSize="small" /></IconButton>
                                </Box>
                                <Grid container spacing={2} alignItems="flex-start">
                                    <Grid item xs={4}>
                                        <Typography variant="caption" color="textSecondary" mb={0.5} display="block">Operator</Typography>
                                        <FormControl fullWidth size="small">
                                            <Select value={currentFilter.operator} onChange={(e) => setCurrentFilter({ ...currentFilter, operator: e.target.value })} sx={{ fontSize: '0.85rem' }}>
                                                <MenuItem value="contains">contains</MenuItem>
                                                <MenuItem value="equals">equals</MenuItem>
                                                <MenuItem value="starts with">starts with</MenuItem>
                                                <MenuItem value="ends with">ends with</MenuItem>
                                                <MenuItem value="is empty">is empty</MenuItem>
                                                <MenuItem value="is not empty">is not empty</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Typography variant="caption" color="textSecondary" mb={0.5} display="block">Value</Typography>
                                        <TextField
                                            fullWidth size="small" placeholder="Filter value" variant="outlined"
                                            value={currentFilter.value} onChange={(e) => setCurrentFilter({ ...currentFilter, value: e.target.value })}
                                            disabled={['is empty', 'is not empty'].includes(currentFilter.operator)}
                                            InputProps={{ sx: { fontSize: '0.85rem' } }}
                                        />
                                    </Grid>
                                </Grid>
                                <Box display="flex" justifyContent="flex-end" mt={2} gap={1}>
                                    <Button size="small" onClick={() => clearFilter()} sx={{ color: '#666', textTransform: 'none', fontWeight: 'bold' }}>Clear</Button>
                                    <Button size="small" variant="contained" onClick={applyFilter} sx={{ bgcolor: '#204f4f', color: '#ffffff', textTransform: 'none', fontWeight: 'bold', '&:hover': { bgcolor: '#153333' } }}>Apply Filter</Button>
                                </Box>
                            </Popover>

                        </Box>
                    </Paper>
                </Box>
            ) : (
                <Box sx={{ pb: 8 }}>
                    {rows.length === 0 ? <Typography align="center" color="textSecondary" sx={{ mt: 5 }}>No records found.</Typography> : rows.map(row => {
                        const initials = row.clientName.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
                        return (
                            <Box key={row.id} sx={{ mb: 1.5, bgcolor: '#fff', borderRadius: 2, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', overflow: 'hidden', border: selectedRows.includes(row.id) ? '1px solid #204f4f' : '1px solid transparent' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', p: 1.5 }}>
                                    {selectionMode && <Checkbox checked={selectedRows.includes(row.id)} onChange={(e) => { if (e.target.checked) setSelectedRows([...selectedRows, row.id]); else setSelectedRows(selectedRows.filter(id => id !== row.id)); }} sx={{ p: 0, mr: 1.5, color: '#c4a161', '&.Mui-checked': { color: '#204f4f' } }} />}
                                    <Avatar onClick={() => setMobileDetailClient(row)} sx={{ bgcolor: '#204f4f', mr: 1.5, width: 32, height: 32, fontSize: '0.8rem', fontWeight: 'bold' }}>{initials}</Avatar>
                                    <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
                                        <Typography onClick={() => setMobileDetailClient(row)} variant="subtitle2" fontWeight="bold" noWrap color="#333" sx={{ cursor: 'pointer' }}>{row.clientName}</Typography>
                                        <Box onClick={(e) => { e.stopPropagation(); if (hasSipAddNote) { setCommentDialog({ open: true, clientCode: row.clientCode, currentComment: row.mobileComment || '' }); } else { setSnackbar({ open: true, msg: 'તમને Mobile Note એડ કરવાની પરવાનગી નથી.', type: 'warning' }); } }} sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, bgcolor: '#f4f6f8', px: 1, py: 0.3, borderRadius: 1.5, mt: 0.5, mb: 0.5, border: '1px solid #e0e6ed', cursor: hasSipAddNote ? 'pointer' : 'default' }}>
                                            <Typography variant="caption" fontWeight="bold" color="#555">{row.mobileNumber}</Typography>
                                            {row.mobileComment && <Typography variant="caption" fontWeight="bold" color="#c4a161">({row.mobileComment})</Typography>}
                                            {hasSipAddNote && <EditIcon sx={{ fontSize: '11px', color: '#888', ml: 0.5 }} />}
                                        </Box>
                                        <Typography onClick={() => setMobileDetailClient(row)} variant="caption" color="textSecondary" noWrap sx={{ display: 'block', cursor: 'pointer' }}>{formatSchemeName(row.schemeName)}</Typography>
                                        <Typography onClick={() => setMobileDetailClient(row)} variant="caption" color="#004d40" fontWeight="bold" sx={{ cursor: 'pointer' }}>SIP Date: {row.sipDate}</Typography>
                                    </Box>
                                    <Box sx={{ textAlign: 'right', ml: 1 }}>
                                        <Typography variant="subtitle2" fontWeight="bold" sx={{ color: '#1565c0' }}>₹{parseFloat(row.amount || 0).toLocaleString('en-IN')}</Typography>
                                        <Box display="flex" alignItems="center" justifyContent="flex-end" mt={0.5}><StatusChip status={row.status || 'Pending'} /></Box>
                                    </Box>
                                    <IconButton size="small" onClick={(e) => setRowMenuAnchor({ el: e.currentTarget, row })} sx={{ ml: 0.5, color: '#666' }}><MoreVertIcon fontSize="small" /></IconButton>
                                </Box>
                            </Box>
                        );
                    })}
                </Box>
            )}

            <SwipeableDrawer anchor="bottom" open={Boolean(mobileDetailClient)} onClose={() => setMobileDetailClient(null)} onOpen={() => { }} disableSwipeToOpen PaperProps={{ sx: { borderTopLeftRadius: 16, borderTopRightRadius: 16, maxHeight: '85vh', bgcolor: '#f4f7f7', backgroundImage: 'none' } }}>
                {mobileDetailClient && (
                    <Box display="flex" flexDirection="column" height="100%">
                        <Box sx={{ display: 'flex', justifyContent: 'center', pt: 1.5, pb: 1 }} onClick={() => setMobileDetailClient(null)}><Box sx={{ width: 40, height: 5, bgcolor: '#bdbdbd', borderRadius: 3 }} /></Box>
                        <Box sx={{ px: 2, pb: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><Typography variant="h6" fontWeight="bold" color="#204f4f">SIP Details</Typography></Box>
                        <Box sx={{ p: 2, flexGrow: 1, overflowY: 'auto' }}>
                            <Paper sx={{ p: 2, mb: 2, borderRadius: 2, borderLeft: '4px solid #c4a161' }}>
                                <Typography variant="subtitle2" fontWeight="bold" mb={1}>{mobileDetailClient.clientName} ({mobileDetailClient.clientCode})</Typography>
                                <Typography variant="body2" mb={0.5}><strong>📞 Mobile:</strong> {mobileDetailClient.mobileNumber} {mobileDetailClient.mobileComment && <Typography component="span" variant="caption" sx={{ color: '#c4a161', ml: 1, fontWeight: 'bold' }}>({mobileDetailClient.mobileComment})</Typography>}</Typography>
                                <Typography variant="body2" mb={0.5}><strong>🏢 Company:</strong> {mobileDetailClient.company}</Typography>
                                <Typography variant="body2" mb={0.5}><strong>🏦 Bank:</strong> {mobileDetailClient.bankName}</Typography>
                            </Paper>
                            <Card sx={{ p: 2, mb: 2, borderRadius: 2, border: '1px solid #e0e0e0', boxShadow: 'none' }}>
                                <Typography variant="body2" fontWeight="bold" color="#333" mb={1}>{mobileDetailClient.schemeName}</Typography>
                                <Typography variant="caption" display="block" color="textSecondary">Category: {mobileDetailClient.category}</Typography>
                                <Typography variant="caption" display="block" color="textSecondary" mb={1}>Sub: {mobileDetailClient.subCategory}</Typography>
                                <Divider sx={{ my: 1 }} />
                                <Box display="flex" justifyContent="space-between" alignItems="center"><Typography variant="caption" fontWeight="bold">Amount:</Typography><Typography variant="subtitle1" fontWeight="bold" color="#1565c0">₹{parseFloat(mobileDetailClient.amount || 0).toLocaleString('en-IN')}</Typography></Box>
                                <Box mt={1} pt={1} borderTop="1px dashed #e0e0e0" display="flex" justifyContent="space-between"><Typography variant="caption" fontWeight="bold">SIP Date:</Typography><Typography variant="caption" fontWeight="bold" color="#004d40">{mobileDetailClient.sipDate}</Typography></Box>
                                <Box mt={1} display="flex" justifyContent="space-between"><Typography variant="caption" fontWeight="bold">Next SIP Date:</Typography><Typography variant="caption" fontWeight="bold" color="#204f4f">{formatDate(mobileDetailClient.nextDate || mobileDetailClient.nextSipDate)}</Typography></Box>
                                <Box mt={1.5} display="flex" justifyContent="space-between" alignItems="center">
                                    <Typography variant="caption" fontWeight="bold">Current Status:</Typography>
                                    <FormControl size="small" sx={{ minWidth: 120, '& .MuiOutlinedInput-root': { bgcolor: mobileDetailClient.statusColor, color: mobileDetailClient.statusText, fontWeight: 'bold', borderRadius: 1.5, height: '30px' } }}>
                                        <Select value={mobileDetailClient.status} onChange={(e) => { handleStatusUpdate(mobileDetailClient, e.target.value); setMobileDetailClient({ ...mobileDetailClient, status: e.target.value, statusColor: e.target.value === 'Success' ? '#e8f5e9' : e.target.value === 'Pending' ? '#e3f2fd' : '#ffebee', statusText: e.target.value === 'Success' ? '#2e7d32' : e.target.value === 'Pending' ? '#1565c0' : '#c62828' }); }} MenuProps={dropdownMenuProps} disabled={!hasSipStatus}>
                                            <MenuItem value="Pending">Pending</MenuItem><MenuItem value="Success">Success</MenuItem><MenuItem value="Failed">Failed</MenuItem><MenuItem value="Bounced">Bounced</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>
                            </Card>
                            {hasSipLogCol && <Button fullWidth variant="outlined" startIcon={<HistoryIcon />} onClick={() => { setMobileDetailClient(null); setSingleHistoryDialog({ open: true, clientCode: mobileDetailClient.clientCode, sipDate: mobileDetailClient.sipDate, name: mobileDetailClient.schemeName, history: mobileDetailClient.history || [] }); fetchAndOpenHistory(); }} sx={{ mb: 1, borderColor: '#1565c0', color: '#1565c0', fontWeight: 'bold' }}>View Full Log</Button>}
                        </Box>
                        <Box sx={{ p: 1.5, bgcolor: '#fff', borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, boxShadow: '0 -2px 10px rgba(0,0,0,0.05)' }}>
                            <Grid container spacing={1}>
                                {hasSipEditCol && <Grid item xs={6}><Button fullWidth variant="outlined" startIcon={<EditIcon />} onClick={() => { setMobileDetailClient(null); handleOpenEditDialog(mobileDetailClient); }} sx={{ borderColor: '#757575', color: '#757575', fontWeight: 'bold' }}>Edit</Button></Grid>}
                                {['Success', 'Reordered', 'Skipped'].includes(mobileDetailClient.status) && hasSipActionCol && <Grid item xs={hasSipEditCol ? 6 : 12}><Button fullWidth variant="contained" startIcon={<CheckCircleIcon />} onClick={() => { handleConfirmCycle(mobileDetailClient); setMobileDetailClient(null); }} sx={{ bgcolor: '#2e7d32', color: 'white', fontWeight: 'bold', '&:hover': { bgcolor: '#1b5e20' } }}>Confirm Next Month</Button></Grid>}
                            </Grid>
                        </Box>
                    </Box>
                )}
            </SwipeableDrawer>

            <Dialog open={waDialog.open} onClose={() => setWaDialog({ ...waDialog, open: false })} maxWidth="sm" fullWidth PaperProps={{ sx: { bgcolor: '#fff', backgroundImage: 'none', borderRadius: 2 } }}>
                <DialogTitle sx={{ bgcolor: '#075E54', color: 'white', fontWeight: 'bold', display: 'flex', alignItems: 'center' }}><WhatsAppIcon sx={{ mr: 1 }} /> Share via WhatsApp</DialogTitle>
                <DialogContent sx={{ mt: 2, bgcolor: '#fff', p: 2 }}><TextField fullWidth multiline rows={8} value={waDialog.msg} onChange={(e) => setWaDialog({ ...waDialog, msg: e.target.value })} sx={{ bgcolor: '#fff' }} /></DialogContent>
                <DialogActions sx={{ p: 1.5, pt: 1, bgcolor: '#fff', borderTop: '1px solid #eee', display: 'flex', gap: 1, justifyContent: 'space-between' }}>
                    <Button variant="outlined" onClick={() => { navigator.clipboard.writeText(waDialog.msg); setSnackbar({ open: true, msg: 'Message Copied to Clipboard!', type: 'success' }); }} sx={{ color: '#204f4f', borderColor: '#ccc', fontWeight: 'bold', fontSize: '0.75rem', minWidth: 0, px: 2 }}>Copy</Button>
                    <Button variant="outlined" onClick={() => setWaDialog({ ...waDialog, open: false })} sx={{ color: '#666', borderColor: '#ccc', fontWeight: 'bold', fontSize: '0.75rem', minWidth: 0, px: 2 }}>Cancel</Button>
                    <Button onClick={() => { window.open(`https://api.whatsapp.com/send?phone=${waDialog.phone}&text=${encodeURIComponent(waDialog.msg)}`, '_blank'); setWaDialog({ ...waDialog, open: false }); }} variant="contained" sx={{ bgcolor: '#204f4f', color: 'white', '&:hover': { bgcolor: '#153333' }, fontWeight: 'bold', fontSize: '0.8rem', flex: 1 }} startIcon={<WhatsAppIcon fontSize="small" />}>Send</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={Boolean(pdfActionData)} onClose={() => setPdfActionData(null)} maxWidth="xs" fullWidth PaperProps={{ sx: { bgcolor: '#fff', backgroundImage: 'none', borderRadius: 2 } }}>
                <DialogTitle sx={{ bgcolor: '#204f4f', color: '#fff', fontWeight: 'bold', display: 'flex', alignItems: 'center' }}><ShareIcon sx={{ mr: 1 }} /> Share PDF</DialogTitle>
                <DialogContent sx={{ mt: 3, textAlign: 'center', bgcolor: '#fff', p: 2 }}>
                    <Typography variant="body1" mb={3} fontWeight="bold" color="#333">Your PDF is ready. What would you like to do?</Typography>
                    <Box display="flex" flexDirection="column" gap={1.5}>
                        <Button variant="contained" startIcon={<CloudDownloadIcon />} onClick={() => { const url = URL.createObjectURL(pdfActionData.blob); const link = document.createElement('a'); link.href = url; link.download = pdfActionData.fileName; link.click(); setPdfActionData(null); }} sx={{ bgcolor: '#204f4f', color: '#fff', py: 1.2, fontWeight: 'bold', '&:hover': { bgcolor: '#e0e0e0', color: '#000000' } }}>Save to Device</Button>
                        <Button variant="outlined" startIcon={<WhatsAppIcon />} onClick={async () => { const file = new File([pdfActionData.blob], pdfActionData.fileName, { type: 'application/pdf' }); if (navigator.share) { try { await navigator.share({ title: 'SIP Reminders', files: [file] }); } catch (e) { console.error(e); } } else { setSnackbar({ open: true, msg: 'Direct file sharing is only available on mobile devices. Please save it first.', type: 'warning' }); } }} sx={{ color: '#075E54', borderColor: '#075E54', py: 1.2, fontWeight: 'bold' }}>Share via WhatsApp / Others</Button>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 1.5, bgcolor: '#fff', borderTop: 'none', justifyContent: 'center' }}><Button variant="outlined" onClick={() => setPdfActionData(null)} sx={{ color: '#666', borderColor: '#ccc', fontWeight: 'bold', width: '100%', py: 1 }}>Cancel</Button></DialogActions>
            </Dialog>

            <Dialog open={uploadDialog} onClose={() => setUploadDialog(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ bgcolor: '#204f4f', color: '#fff', fontWeight: 'bold' }}>Excel Upload Settings</DialogTitle>
                <DialogContent sx={{ bgcolor: '#fafafa' }}>
                    <Typography variant="body1" sx={{ color: '#333', mt: 3 }}>How do you want to handle duplicate SIPs?<br /><small>(Same Client + Same Scheme + Same SIP Date)</small></Typography>
                    <FormControl component="fieldset">
                        <RadioGroup value={uploadStrategy} onChange={(e) => setUploadStrategy(e.target.value)}>
                            <FormControlLabel value="accumulate" control={<Radio sx={{ color: '#204f4f', '&.Mui-checked': { color: '#204f4f' } }} />} label={<Typography fontWeight="bold">Add/Accumulate Amount (Existing + New Excel data)</Typography>} />
                            <FormControlLabel value="skip" control={<Radio sx={{ color: '#204f4f', '&.Mui-checked': { color: '#204f4f' } }} />} label={<Typography fontWeight="bold">Skip Duplicate (Keep existing data as is)</Typography>} />
                        </RadioGroup>
                    </FormControl>
                </DialogContent>
                <DialogActions sx={{ p: 2, bgcolor: '#eceff1' }}><Button onClick={() => setUploadDialog(false)} color="inherit" sx={{ fontWeight: 'bold' }}>Cancel</Button><Button onClick={handleConfirmUpload} variant="contained" sx={{ bgcolor: '#204f4f', color: 'white' }}>Confirm & Upload</Button></DialogActions>
            </Dialog>

            {/* 🔥 History Dashboard keeps DataGrid because it uses filtering/pagination inside a dialog */}
            <Dialog open={historyDialog.open} onClose={() => setHistoryDialog({ open: false, list: [] })} maxWidth="xl" fullWidth fullScreen={isMobile} PaperProps={{ sx: { bgcolor: '#fff', backgroundImage: 'none' } }}>
                <DialogTitle sx={{ bgcolor: '#204f4f', color: '#ffffff', fontWeight: 'bold', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="h6" fontWeight="bold">SIP History Dashboard</Typography>
                    {isMobile && <IconButton size="small" onClick={() => setHistoryDialog({ open: false, list: [] })} sx={{ color: 'white' }}><CloseIcon /></IconButton>}
                </DialogTitle>
                <DialogContent sx={{ p: isMobile ? 1 : 0, bgcolor: '#ffffff' }}>
                    {isMobile && <Box sx={{ mb: 2, mt: 1 }}><TextField fullWidth size="small" placeholder="Search Client or Scheme..." variant="outlined" defaultValue={historySearch} onChange={(e) => { if (window.mobHistTimer) clearTimeout(window.mobHistTimer); window.mobHistTimer = setTimeout(() => setHistorySearch(e.target.value), 350); }} autoComplete="off" spellCheck="false" InputProps={{ startAdornment: (<InputAdornment position="start"><SearchIcon sx={{ color: '#204f4f' }} /></InputAdornment>) }} sx={{ bgcolor: 'white', borderRadius: 2 }} /></Box>}
                    <Box sx={{ height: 600, width: '100%', display: { xs: 'none', md: 'block' } }}>
                        <DataGrid
                            rows={filteredHistoryRows} columns={historyColumns} getRowId={(row) => row.internalId} getRowHeight={() => 'auto'} disableRowSelectionOnClick slots={{ toolbar: HistoryToolbar }} slotProps={{ toolbar: { search: historySearch, setSearch: setHistorySearch } }} getRowClassName={(p) => p.row.rowClass}
                            sx={{
                                border: 'none', backgroundColor: '#ffffff',
                                '&.MuiDataGrid-root--densityCompact .MuiDataGrid-columnHeaders': { minHeight: '40px !important', maxHeight: '40px !important' },
                                '&.MuiDataGrid-root--densityStandard .MuiDataGrid-columnHeaders': { minHeight: '50px !important', maxHeight: '50px !important' },
                                '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-columnHeaders': { minHeight: '60px !important', maxHeight: '60px !important' },
                                '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '2px' }, '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '10px' }, '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '20px' },
                                '& .MuiDataGrid-columnHeaders': { backgroundColor: '#204f4f', color: '#ffffff', fontSize: '0.9rem', fontWeight: 'bold' }, '& .MuiDataGrid-iconSeparator': { color: 'transparent' }, '& .MuiDataGrid-menuIcon .MuiSvgIcon-root': { color: 'white' }, '& .MuiDataGrid-sortIcon': { color: 'white' }, '& .MuiCheckbox-root': { color: '#204f4f' }, '& .MuiDataGrid-columnHeader .MuiCheckbox-root': { color: 'white' },
                                '& .odd-row': { backgroundColor: '#e9eff0' }, '& .even-row': { backgroundColor: '#ffffff' }, '& .MuiDataGrid-row:hover': { backgroundColor: '#fdfbf7 !important' }, '& .MuiDataGrid-cell': { borderBottom: '1px solid #f0f0f0', outline: 'none !important' }, '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus': { outline: 'none' },
                                '& ::-webkit-scrollbar': { width: '4px', height: '3px' }, '& ::-webkit-scrollbar-track': { background: 'transparent' }, '& ::-webkit-scrollbar-thumb': { background: '#e0e0e0', borderRadius: '10px' }, '& ::-webkit-scrollbar-thumb:hover': { background: '#bdbdbd' }
                            }}
                        />
                    </Box>
                    <Box sx={{ display: { xs: 'block', md: 'none' }, pb: 2 }}>
                        {filteredHistoryRows.length === 0 ? <Typography align="center" color="textSecondary" sx={{ mt: 5 }}>No history found.</Typography> : (
                            filteredHistoryRows.map(row => {
                                const initials = row.clientName.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
                                return (
                                    <Box key={row.internalId} sx={{ mb: 1.5, bgcolor: '#fff', borderRadius: 2, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', overflow: 'hidden', border: '1px solid #e0e0e0' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', p: 1.5 }}>
                                            <Avatar sx={{ bgcolor: '#204f4f', mr: 1.5, width: 32, height: 32, fontSize: '0.8rem', fontWeight: 'bold' }}>{initials}</Avatar>
                                            <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
                                                <Typography variant="subtitle2" fontWeight="bold" noWrap color="#333">{row.clientName}</Typography>
                                                <Typography variant="caption" color="textSecondary" noWrap sx={{ display: 'block' }}>{formatSchemeName(row.schemeName)}</Typography>
                                            </Box>
                                            <Box sx={{ textAlign: 'right', ml: 1 }}>
                                                <Typography variant="subtitle2" fontWeight="bold" sx={{ color: '#1565c0' }}>₹{row.latestLog ? row.latestLog.amount : 0}</Typography>
                                                <Box mt={0.5}><StatusChip status={row.latestLog ? row.latestLog.status : 'Pending'} /></Box>
                                            </Box>
                                        </Box>
                                        <Divider />
                                        <Box sx={{ p: 1, bgcolor: '#fdfbf7', textAlign: 'center' }}>
                                            <Button size="small" variant="text" sx={{ color: '#1565c0', fontWeight: 'bold', width: '100%' }} onClick={() => setSingleHistoryDialog({ open: true, clientCode: row.clientCode, sipDate: row.sipDate, name: row.schemeName, history: row.history })}>View Full Log</Button>
                                        </Box>
                                    </Box>
                                )
                            })
                        )}
                    </Box>
                </DialogContent>
                {!isMobile && (
                    <DialogActions sx={{ p: 2, bgcolor: '#eceff1', display: 'flex', justifyContent: 'space-between' }}>
                        <Box>
                            {hasSipExportHistory && <Button variant="outlined" startIcon={<CloudDownloadIcon />} onClick={handleExportHistory} sx={{ mr: 1, color: '#1565c0', borderColor: '#1565c0', fontWeight: 'bold' }}>Export</Button>}
                            {hasSipUpload && <Button component="label" variant="outlined" startIcon={<CloudUploadIcon />} sx={{ color: '#2e7d32', borderColor: '#2e7d32', fontWeight: 'bold' }}>Import History<input type="file" hidden accept=".xlsx" onChange={handleHistoryUpload} /></Button>}
                        </Box>
                        <Button onClick={() => setHistoryDialog({ open: false, list: [] })} sx={{ fontWeight: 'bold', color: '#204f4f' }}>Close</Button>
                    </DialogActions>
                )}
            </Dialog>

            <Dialog open={singleHistoryDialog.open} onClose={() => setSingleHistoryDialog({ open: false, clientCode: '', clientName: '', sipDate: '', name: '', history: [] })} maxWidth="md" fullWidth fullScreen={isMobile} PaperProps={{ sx: { bgcolor: '#fff', backgroundImage: 'none' } }}>
                <DialogTitle sx={{ bgcolor: '#204f4f', color: 'white', fontWeight: 'bold', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="h6" fontWeight="bold">
                        Full SIP Log - {singleHistoryDialog.clientName} ({singleHistoryDialog.clientCode})
                    </Typography>
                    {isMobile && <IconButton size="small" onClick={() => setSingleHistoryDialog({ open: false, clientCode: '', clientName: '', sipDate: '', name: '', history: [] })} sx={{ color: 'white' }}><CloseIcon /></IconButton>}
                </DialogTitle>
                <DialogContent sx={{ p: isMobile ? 2 : 0, bgcolor: isMobile ? '#fafafa' : '#ffffff' }}>
                    <Box sx={{ mb: 2, mt: isMobile ? 1 : 2, px: isMobile ? 0 : 2 }}><Typography variant="subtitle1" color={isMobile ? '#204f4f' : 'inherit'} fontWeight="bold">{singleHistoryDialog.name}</Typography></Box>
                    <Box sx={{ height: 400, width: '100%', display: { xs: 'none', md: 'block' } }}>
                        <DataGrid
                            rows={singleHistoryRows} columns={singleHistoryColumns} getRowId={(row) => row.id} disableRowSelectionOnClick hideFooter getRowClassName={(p) => p.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row'}
                            sx={{
                                border: 'none', backgroundColor: '#ffffff',
                                '&.MuiDataGrid-root--densityCompact .MuiDataGrid-columnHeaders': { minHeight: '40px !important', maxHeight: '40px !important' },
                                '&.MuiDataGrid-root--densityStandard .MuiDataGrid-columnHeaders': { minHeight: '50px !important', maxHeight: '50px !important' },
                                '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-columnHeaders': { minHeight: '60px !important', maxHeight: '60px !important' },
                                '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '2px' }, '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '10px' }, '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '20px' },
                                '& .MuiDataGrid-columnHeaders': { backgroundColor: '#204f4f', color: '#ffffff', fontSize: '0.9rem', fontWeight: 'bold' }, '& .MuiDataGrid-iconSeparator': { color: 'transparent' }, '& .MuiDataGrid-menuIcon .MuiSvgIcon-root': { color: 'white' }, '& .MuiDataGrid-sortIcon': { color: 'white' }, '& .MuiCheckbox-root': { color: '#204f4f' }, '& .MuiDataGrid-columnHeader .MuiCheckbox-root': { color: 'white' },
                                '& .odd-row': { backgroundColor: '#e9eff0' }, '& .even-row': { backgroundColor: '#ffffff' }, '& .MuiDataGrid-row:hover': { backgroundColor: '#fdfbf7 !important' }, '& .MuiDataGrid-cell': { borderBottom: '1px solid #f0f0f0', outline: 'none !important' }, '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus': { outline: 'none' },
                                '& ::-webkit-scrollbar': { width: '4px', height: '3px' }, '& ::-webkit-scrollbar-track': { background: 'transparent' }, '& ::-webkit-scrollbar-thumb': { background: '#e0e0e0', borderRadius: '10px' }, '& ::-webkit-scrollbar-thumb:hover': { background: '#bdbdbd' }
                            }}
                        />
                    </Box>
                    <Box sx={{ display: { xs: 'block', md: 'none' }, pb: 2 }}>
                        {singleHistoryRows.map((row) => (
                            <Card key={row.id} sx={{ mb: 1.5, borderRadius: 2, border: '1px solid #e0e0e0', boxShadow: 'none' }}>
                                <Box p={1.5}>
                                    <Box display="flex" justifyContent="space-between" mb={1}><Typography variant="body2" fontWeight="bold">Cycle: {row.cycleMonth}</Typography><StatusChip status={row.status} /></Box>
                                    <Divider sx={{ my: 1 }} />
                                    <Box display="flex" justifyContent="space-between" mb={0.5}><Typography variant="caption" color="textSecondary">Executed On:</Typography><Typography variant="caption" fontWeight="bold">{formatDateTime(row.executedOn)}</Typography></Box>
                                    <Box display="flex" justifyContent="space-between" alignItems="center"><Typography variant="caption" color="textSecondary">Amount:</Typography><Typography variant="subtitle2" color="#204f4f" fontWeight="bold">₹{row.amount}</Typography></Box>
                                    {row.isFirst && hasSipUndo && <Box mt={1.5} pt={1} borderTop="1px dashed #e0e0e0" textAlign="right"><Button size="small" color="error" variant="outlined" startIcon={<UndoIcon />} onClick={() => triggerUndo(singleHistoryDialog.clientCode, singleHistoryDialog.name, singleHistoryDialog.sipDate)}>Undo Action</Button></Box>}
                                </Box>
                            </Card>
                        ))}
                    </Box>
                </DialogContent>
                {!isMobile && <DialogActions sx={{ p: 2, bgcolor: '#eceff1' }}><Button onClick={() => setSingleHistoryDialog({ open: false, clientCode: '', sipDate: '', name: '', history: [] })} sx={{ fontWeight: 'bold', color: '#204f4f' }}>Close</Button></DialogActions>}
            </Dialog>

            <Dialog open={undoDialog.open} onClose={() => setUndoDialog({ ...undoDialog, open: false })} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ bgcolor: '#ffebee', color: '#c62828', fontWeight: 'bold' }}>Confirm Undo Action</DialogTitle>
                <DialogContent sx={{ mt: 3 }}>
                    <Typography variant="body1" sx={{ color: '#333', mt: 2 }}>Are you sure you want to <b>UNDO</b> the last cycle for <br /><span style={{ color: '#204f4f', fontWeight: 'bold' }}>{undoDialog.schemeName}</span>?<br /><br />This will remove the latest history log, pull the Date back by 1 month, and restore the old status.</Typography>
                </DialogContent>
                <DialogActions sx={{ p: 2, bgcolor: '#eceff1' }}><Button onClick={() => setUndoDialog({ ...undoDialog, open: false })} color="inherit" sx={{ fontWeight: 'bold' }}>Cancel</Button><Button onClick={confirmUndoAction} variant="contained" sx={{ bgcolor: '#c62828', color: 'white', '&:hover': { bgcolor: '#b71c1c' } }}>Confirm Undo</Button></DialogActions>
            </Dialog>

            <Dialog open={processCycleDialog} onClose={() => setProcessCycleDialog(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ bgcolor: '#e8f5e9', color: '#1b5e20', fontWeight: 'bold' }}>Process Next Cycle</DialogTitle>
                <DialogContent sx={{ pt: 3, bgcolor: '#ffffff' }}>
                    <Typography variant="body1" sx={{ color: '#333', mt: 2 }}>Are you sure you want to process the next cycle? <br /><br />This action will take <b>ALL</b> SIPs in the table currently marked as <b><span style={{ color: 'green' }}>Success</span>, <span style={{ color: 'blue' }}>Reordered</span>,</b> or <b><span style={{ color: 'orange' }}>Skipped</span></b>, save them to the History Log, and automatically advance their "Next SIP Date" to the upcoming month with a "Pending" status.</Typography>
                </DialogContent>
                <DialogActions sx={{ p: 2, bgcolor: '#eceff1' }}><Button onClick={() => setProcessCycleDialog(false)} color="inherit" sx={{ fontWeight: 'bold' }}>Cancel</Button><Button onClick={executeProcessCycle} variant="contained" sx={{ bgcolor: '#1b5e20', color: 'white', '&:hover': { bgcolor: '#144d18' } }}>Confirm & Process</Button></DialogActions>
            </Dialog>

            <Dialog open={deleteConfirmDialog} onClose={() => setDeleteConfirmDialog(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ bgcolor: '#ffebee', color: '#c62828', fontWeight: 'bold', display: 'flex', alignItems: 'center' }}><DeleteIcon sx={{ mr: 1 }} /> Confirm Deletion</DialogTitle>
                <DialogContent sx={{ bgcolor: '#fafafa' }}><Typography variant="body1" sx={{ color: '#333', mt: 3 }}>Are you sure you want to delete <b>{selectedRows.length}</b> selected records?<br /><br /><span style={{ color: '#c62828', fontWeight: 'bold' }}>Warning:</span> This action cannot be undone.</Typography></DialogContent>
                <DialogActions sx={{ p: 2, bgcolor: '#eceff1', justifyContent: 'flex-end' }}><Button onClick={() => setDeleteConfirmDialog(false)} color="inherit" sx={{ fontWeight: 'bold', mr: 1 }}>Cancel</Button><Button onClick={executeBulkDelete} variant="contained" sx={{ bgcolor: '#c62828', color: 'white', '&:hover': { bgcolor: '#b71c1c' } }}>Confirm Delete</Button></DialogActions>
            </Dialog>

            {/* 🔥 Full Page Edit Dialog */}
            <Dialog
                open={editDialog.open}
                onClose={() => setEditDialog({ open: false, clientCode: '', oldSchemeName: '', oldSipDate: '', amount: '', sipDate: '', bankName: '', mobileNumber: '', company: '' })}
                maxWidth="xl"
                fullWidth
                fullScreen={isMobile}
                PaperProps={{ sx: { borderRadius: isMobile ? 0 : 3, bgcolor: '#fff', backgroundImage: 'none' } }}
                TransitionComponent={Transition}
            >
                <DialogTitle sx={{ bgcolor: '#204f4f', color: '#fff', fontWeight: 'bold', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="h6" fontWeight="bold">Edit SIP Client</Typography>
                    {isMobile && <IconButton size="small" onClick={() => setEditDialog({ open: false, clientCode: '', oldSchemeName: '', oldSipDate: '', amount: '', sipDate: '', bankName: '', mobileNumber: '', company: '' })} sx={{ color: 'white' }}><CloseIcon /></IconButton>}
                </DialogTitle>
                <DialogContent sx={{ pt: 3, mt: 1, bgcolor: '#fafafa', overflowX: 'hidden' }}>
                    <Typography variant="subtitle1" fontWeight="bold" color="#204f4f" mb={2}>Client Details</Typography>
                    <Box display="flex" flexDirection={isMobile ? 'column' : 'row'} gap={2} mb={4} width="100%">
                        <Box sx={{ flex: 1 }}>
                            <TextField
                                label="Client Code"
                                size="small"
                                fullWidth
                                value={editDialog.clientCode}
                                onChange={e => setEditDialog({ ...editDialog, clientCode: e.target.value.toUpperCase() })}
                            />
                        </Box>
                        <Box sx={{ flex: 1.5 }}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Client Name"
                                value={editDialog.clientName || ''}
                                onChange={e => setEditDialog({ ...editDialog, clientName: e.target.value })}
                            />
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Mobile"
                                value={editDialog.mobileNumber}
                                onChange={e => setEditDialog({ ...editDialog, mobileNumber: e.target.value })}
                            />
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Company</InputLabel>
                                <Select value={editDialog.company || 'Angel One'} label="Company" onChange={e => setEditDialog({ ...editDialog, company: e.target.value })} MenuProps={dropdownMenuProps}>
                                    <MenuItem value="Angel One">Angel One</MenuItem>
                                    <MenuItem value="Wealthy">Wealthy</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                    </Box>
                    <Divider sx={{ mb: 3 }} />
                    <Typography variant="subtitle1" fontWeight="bold" color="#204f4f" mb={2}>Scheme Allocation</Typography>

                    <Box display="flex" flexDirection={isMobile ? 'column' : 'row'} gap={1.5} alignItems={isMobile ? 'flex-start' : 'center'} mb={2} width="100%" sx={{ p: isMobile ? 2 : 0, border: isMobile ? '1px solid #e0e0e0' : 'none', borderRadius: 2 }}>
                        <Box sx={{ width: '100%', flex: 1 }}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Category</InputLabel>
                                <Select value={editDialog.category || ''} label="Category" onChange={e => setEditDialog({ ...editDialog, category: e.target.value, subCategory: '', schemeName: '' })} MenuProps={dropdownMenuProps}>
                                    {categories.map(cat => <MenuItem key={cat} value={cat}>{cat}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </Box>
                        <Box sx={{ width: '100%', flex: 1.2 }}>
                            <FormControl fullWidth size="small" disabled={!editDialog.category}>
                                <InputLabel>Sub Category</InputLabel>
                                <Select value={editDialog.subCategory || ''} label="Sub Category" onChange={e => setEditDialog({ ...editDialog, subCategory: e.target.value, schemeName: '' })} MenuProps={dropdownMenuProps}>
                                    {getSubCat(editDialog.category).map(sub => <MenuItem key={sub} value={sub}>{sub}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </Box>
                        <Box sx={{ width: '100%', flex: 2 }}>
                            <Autocomplete
                                disabled={!editDialog.subCategory}
                                options={getSch(editDialog.category, editDialog.subCategory)}
                                value={editDialog.oldSchemeName || null}
                                onChange={(e, val) => setEditDialog({ ...editDialog, oldSchemeName: val || '' })}
                                ListboxProps={autocompleteListboxProps}
                                renderInput={(p) => <TextField {...p} label="Smart Scheme Search" size="small" fullWidth />}
                            />
                        </Box>
                        <Box sx={{ width: '100%', flex: 1 }}>
                            <Autocomplete
                                freeSolo
                                options={uniqueBanks}
                                value={editDialog.bankName || ''}
                                onInputChange={(e, val) => setEditDialog({ ...editDialog, bankName: val || '' })}
                                ListboxProps={autocompleteListboxProps}
                                renderInput={(p) => <TextField {...p} label="Bank Name" size="small" fullWidth />}
                            />
                        </Box>
                        <Box sx={{ width: '100%', flex: 0.6 }}>
                            <FormControl fullWidth size="small">
                                <InputLabel>SIP Date</InputLabel>
                                <Select value={editDialog.sipDate || ''} label="SIP Date" onChange={e => setEditDialog({ ...editDialog, sipDate: e.target.value })} MenuProps={dropdownMenuProps}>
                                    {[...Array(28)].map((_, i) => (<MenuItem key={i + 1} value={(i + 1).toString()}>{i + 1}</MenuItem>))}
                                </Select>
                            </FormControl>
                        </Box>
                        <Box sx={{ width: '100%', flex: 0.8 }}>
                            <TextField fullWidth size="small" label="Amount (₹)" type="number" value={editDialog.amount || ''} onChange={e => setEditDialog({ ...editDialog, amount: e.target.value })} />
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 2, bgcolor: '#eceff1' }}>
                    <Button onClick={() => setEditDialog({ open: false, clientCode: '', oldSchemeName: '', oldSipDate: '', amount: '', sipDate: '', bankName: '', mobileNumber: '', company: '' })} color="inherit" sx={{ fontWeight: 'bold' }}>Cancel</Button>
                    <Button onClick={handleSaveEdit} variant="contained" sx={{ bgcolor: '#204f4f', color: 'white', fontWeight: 'bold', '&:hover': { bgcolor: '#cfd8dc', color: '#000000' } }}>Save Changes</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openManualDialog} onClose={() => setOpenManualDialog(false)} maxWidth="xl" fullWidth fullScreen={isMobile} PaperProps={{ sx: { borderRadius: isMobile ? 0 : 3, bgcolor: '#fff', backgroundImage: 'none' } }}>
                <DialogTitle sx={{ bgcolor: '#204f4f', color: '#fff', fontWeight: 'bold', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="h6" fontWeight="bold">Add SIP Client</Typography>
                    {isMobile && <IconButton size="small" onClick={() => setOpenManualDialog(false)} sx={{ color: 'white' }}><CloseIcon /></IconButton>}
                </DialogTitle>
                <DialogContent sx={{ pt: 3, mt: 1, bgcolor: '#fafafa', overflowX: 'hidden' }}>
                    <Typography variant="subtitle1" fontWeight="bold" color="#204f4f" mb={2}>Client Details</Typography>
                    <Box display="flex" flexDirection={isMobile ? 'column' : 'row'} gap={2} mb={4} width="100%">
                        <Box sx={{ flex: 1 }}><Autocomplete freeSolo options={regClients.map(c => c.clientCode)} value={clientInfo.clientCode} onInputChange={(e, val) => handleCodeChange(val || '')} ListboxProps={autocompleteListboxProps} renderInput={(p) => <TextField {...p} label="Client Code" size="small" fullWidth />} /></Box>
                        <Box sx={{ flex: 1.5 }}><TextField fullWidth size="small" label="Client Name" value={clientInfo.clientName} onChange={e => setClientInfo({ ...clientInfo, clientName: toTitleCase(e.target.value) })} /></Box>
                        <Box sx={{ flex: 1 }}><TextField fullWidth size="small" label="Mobile" value={clientInfo.mobileNumber} onChange={e => setClientInfo({ ...clientInfo, mobileNumber: e.target.value })} /></Box>
                        <Box sx={{ flex: 1 }}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Company</InputLabel>
                                <Select value={clientInfo.company} label="Company" onChange={e => setClientInfo({ ...clientInfo, company: e.target.value })} MenuProps={dropdownMenuProps}>
                                    <MenuItem value="Angel One">Angel One</MenuItem>
                                    <MenuItem value="Wealthy">Wealthy</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                    </Box>
                    <Divider sx={{ mb: 3 }} />
                    <Typography variant="subtitle1" fontWeight="bold" color="#204f4f" mb={2}>Scheme Allocations</Typography>
                    {investments.map((inv, idx) => (
                        <Box display="flex" flexDirection={isMobile ? 'column' : 'row'} gap={1.5} alignItems={isMobile ? 'flex-start' : 'center'} mb={2} width="100%" key={idx} sx={{ p: isMobile ? 2 : 0, border: isMobile ? '1px solid #e0e0e0' : 'none', borderRadius: 2 }}>
                            <Box sx={{ width: '100%', flex: 1 }}>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Category</InputLabel>
                                    <Select value={inv.category} label="Category" onChange={e => handleInvChange(idx, 'category', e.target.value)} MenuProps={dropdownMenuProps}>
                                        {categories.map(cat => <MenuItem key={cat} value={cat}>{cat}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box sx={{ width: '100%', flex: 1.2 }}>
                                <FormControl fullWidth size="small" disabled={!inv.category}>
                                    <InputLabel>Sub Category</InputLabel>
                                    <Select value={inv.subCategory} label="Sub Category" onChange={e => handleInvChange(idx, 'subCategory', e.target.value)} MenuProps={dropdownMenuProps}>
                                        {getSubCat(inv.category).map(sub => <MenuItem key={sub} value={sub}>{sub}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box sx={{ width: '100%', flex: 2 }}><Autocomplete disabled={!inv.subCategory} options={getSch(inv.category, inv.subCategory)} value={inv.schemeName || null} onChange={(e, val) => handleInvChange(idx, 'schemeName', val || '')} ListboxProps={autocompleteListboxProps} renderInput={(p) => <TextField {...p} label="Smart Scheme Search" size="small" fullWidth />} /></Box>
                            <Box sx={{ width: '100%', flex: 1 }}><Autocomplete freeSolo options={uniqueBanks} value={inv.bankName || ''} onInputChange={(e, val) => handleInvChange(idx, 'bankName', val || '')} ListboxProps={autocompleteListboxProps} renderInput={(p) => <TextField {...p} label="Bank Name" size="small" fullWidth />} /></Box>
                            <Box sx={{ width: '100%', flex: 0.6 }}>
                                <FormControl fullWidth size="small">
                                    <InputLabel>SIP Date</InputLabel>
                                    <Select value={inv.sipDate} label="SIP Date" onChange={e => handleInvChange(idx, 'sipDate', e.target.value)} MenuProps={dropdownMenuProps}>
                                        {[...Array(28)].map((_, i) => (<MenuItem key={i + 1} value={(i + 1).toString()}>{i + 1}</MenuItem>))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box sx={{ width: '100%', flex: 0.8 }}><TextField fullWidth size="small" label="Amount (₹)" type="number" value={inv.amount} onChange={e => handleInvChange(idx, 'amount', e.target.value)} /></Box>
                            {investments.length > 1 && <Box sx={{ width: isMobile ? '100%' : '40px', display: 'flex', justifyContent: isMobile ? 'flex-end' : 'center', mt: isMobile ? 1 : 0 }}>{isMobile ? <Button color="error" size="small" onClick={() => handleRemoveRow(idx)} startIcon={<DeleteIcon />}>Remove Scheme</Button> : <IconButton color="error" onClick={() => handleRemoveRow(idx)}><DeleteIcon /></IconButton>}</Box>}
                        </Box>
                    ))}
                    <Button startIcon={<AddCircleIcon />} onClick={handleAddRow} sx={{ mt: 2, color: '#c4a161', fontWeight: 'bold' }}>Add Another Scheme</Button>
                </DialogContent>
                <DialogActions sx={{ p: 2, bgcolor: '#eceff1' }}><Button onClick={() => setOpenManualDialog(false)} color="inherit" sx={{ fontWeight: 'bold' }}>Cancel</Button><Button onClick={handleSaveManual} variant="contained" sx={{ bgcolor: '#204f4f', color: 'white', fontWeight: 'bold', '&:hover': { bgcolor: '#cfd8dc', color: '#000000' } }}>Save SIP</Button></DialogActions>
            </Dialog>

            <Dialog open={commentDialog.open} onClose={() => setCommentDialog({ ...commentDialog, open: false })} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '16px', overflow: 'hidden', boxShadow: '0 8px 32px rgba(0,0,0,0.15)', backgroundImage: 'none' } }}>
                <Box sx={{ bgcolor: '#f8fbfc', px: 3, py: 2.5, borderBottom: '1px solid #eef2f5', display: 'flex', alignItems: 'center', gap: 1.5 }}><Avatar sx={{ bgcolor: '#e0f2f1', color: '#204f4f', width: 40, height: 40 }}><EditIcon fontSize="small" /></Avatar><Box><Typography variant="h6" fontWeight="bold" color="#1a3b3b" sx={{ lineHeight: 1.2 }}>Add Mobile Note</Typography><Typography variant="caption" color="#667a8a" fontWeight="500">Quick reference for this contact</Typography></Box></Box>
                <DialogContent sx={{ px: 3, pt: 3, pb: 4, bgcolor: '#ffffff' }}><Typography variant="body2" color="#546e7a" mb={3} sx={{ lineHeight: 1.6 }}>Add a brief, helpful note for this mobile number to easily identify it later (e.g., <i>"Son's number"</i>, <i>"Wife's account"</i>).</Typography><TextField autoFocus fullWidth label="Enter your note here" variant="outlined" value={commentDialog.currentComment} onChange={(e) => setCommentDialog({ ...commentDialog, currentComment: e.target.value })} InputProps={{ sx: { borderRadius: 2, bgcolor: '#fafafa', '&:hover': { bgcolor: '#ffffff' }, transition: 'all 0.2s ease' } }} /></DialogContent>
                <Box sx={{ px: 3, py: 2, bgcolor: '#fbfcfd', borderTop: '1px solid #f0f4f8', display: 'flex', justifyContent: 'flex-end', gap: 1.5 }}><Button onClick={() => setCommentDialog({ ...commentDialog, open: false })} sx={{ color: '#546e7a', fontWeight: 'bold', textTransform: 'none', px: 2, '&:hover': { bgcolor: '#f0f4f8' } }}>Cancel</Button><Button onClick={handleSaveComment} variant="contained" disableElevation sx={{ bgcolor: '#204f4f', color: '#ffffff', fontWeight: 'bold', textTransform: 'none', px: 3, borderRadius: '8px', '&:hover': { bgcolor: '#143636', boxShadow: '0 4px 10px rgba(32,79,79,0.2)' } }}>Save Note</Button></Box>
            </Dialog>

            <Dialog open={bulkStatusDialog.open} onClose={() => setBulkStatusDialog({ ...bulkStatusDialog, open: false })} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '16px', overflow: 'hidden', boxShadow: '0 8px 32px rgba(0,0,0,0.15)', backgroundImage: 'none' } }}>
                <Box sx={{ bgcolor: '#f8fbfc', px: 3, py: 2.5, borderBottom: '1px solid #eef2f5', display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Avatar sx={{ bgcolor: '#e0f2f1', color: '#204f4f', width: 40, height: 40 }}>
                        <PendingActionsIcon fontSize="small" />
                    </Avatar>
                    <Box>
                        <Typography variant="h6" fontWeight="bold" color="#1a3b3b" sx={{ lineHeight: 1.2 }}>Bulk Status Update</Typography>
                        <Typography variant="caption" color="#667a8a" fontWeight="500">Update {selectedRows.length} selected SIPs</Typography>
                    </Box>
                </Box>
                <DialogContent sx={{ px: 3, pt: 3, pb: 4, bgcolor: '#ffffff' }}>
                    <Typography variant="body2" color="#546e7a" mb={3} sx={{ lineHeight: 1.6 }}>
                        Select the new status to apply to all <b>{selectedRows.length}</b> selected SIP records.
                    </Typography>
                    <FormControl fullWidth size="small">
                        {(() => {
                            const bulkColors = {
                                'Success': { color: '#2e7d32', bg: '#e8f5e9' },
                                'Failed': { color: '#d32f2f', bg: '#ffebee' },
                                'Skipped': { color: '#ed6c02', bg: '#fff3e0' },
                                'Reordered': { color: '#1976d2', bg: '#e3f2fd' },
                                'Reminded': { color: '#9c27b0', bg: '#f3e5f5' },
                                'Pending': { color: '#616161', bg: '#f5f5f5' },
                            }[bulkStatusDialog.status] || { color: '#616161', bg: '#f5f5f5' };

                            return (
                                <Select
                                    value={bulkStatusDialog.status}
                                    onChange={(e) => setBulkStatusDialog({ ...bulkStatusDialog, status: e.target.value })}
                                    MenuProps={dropdownMenuProps}
                                    sx={{
                                        borderRadius: 2,
                                        fontWeight: 'bold',
                                        color: bulkColors.color,
                                        backgroundColor: bulkColors.bg,
                                        height: 40,
                                        '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e0e0e0' },
                                        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#bdbdbd' },
                                        '& .MuiSvgIcon-root': { color: bulkColors.color }
                                    }}
                                >
                                    <MenuItem value="Pending"><Box display="flex" alignItems="center"><PendingActionsIcon fontSize="small" sx={{ mr: 1.5, color: '#616161' }} /><span style={{ color: '#616161', fontWeight: 'bold' }}>Pending</span></Box></MenuItem>
                                    <MenuItem value="Reminded"><Box display="flex" alignItems="center"><PendingActionsIcon fontSize="small" sx={{ mr: 1.5, color: '#9c27b0' }} /><span style={{ color: '#9c27b0', fontWeight: 'bold' }}>Reminded</span></Box></MenuItem>
                                    <MenuItem value="Skipped"><Box display="flex" alignItems="center"><CancelIcon fontSize="small" sx={{ mr: 1.5, color: '#ed6c02' }} /><span style={{ color: '#ed6c02', fontWeight: 'bold' }}>Skipped</span></Box></MenuItem>
                                    <MenuItem value="Success" disabled={!canCompleteBulkSip}><Box display="flex" alignItems="center"><CheckCircleIcon fontSize="small" sx={{ mr: 1.5, color: !canCompleteBulkSip ? 'grey' : '#2e7d32' }} /><span style={{ color: !canCompleteBulkSip ? 'grey' : '#2e7d32', fontWeight: 'bold' }}>Success</span></Box></MenuItem>
                                    <MenuItem value="Failed" disabled={!canCompleteBulkSip}><Box display="flex" alignItems="center"><CancelIcon fontSize="small" sx={{ mr: 1.5, color: !canCompleteBulkSip ? 'grey' : '#d32f2f' }} /><span style={{ color: !canCompleteBulkSip ? 'grey' : '#d32f2f', fontWeight: 'bold' }}>Failed</span></Box></MenuItem>
                                    <MenuItem value="Reordered" disabled={!canCompleteBulkSip}><Box display="flex" alignItems="center"><CheckCircleIcon fontSize="small" sx={{ mr: 1.5, color: !canCompleteBulkSip ? 'grey' : '#1976d2' }} /><span style={{ color: !canCompleteBulkSip ? 'grey' : '#1976d2', fontWeight: 'bold' }}>Reordered</span></Box></MenuItem>
                                </Select>
                            );
                        })()}
                    </FormControl>
                </DialogContent>
                <Box sx={{ px: 3, py: 2, bgcolor: '#fbfcfd', borderTop: '1px solid #f0f4f8', display: 'flex', justifyContent: 'flex-end', gap: 1.5 }}>
                    <Button onClick={() => setBulkStatusDialog({ ...bulkStatusDialog, open: false })} sx={{ color: '#546e7a', fontWeight: 'bold', textTransform: 'none', px: 2, '&:hover': { bgcolor: '#f0f4f8' } }}>Cancel</Button>
                    <Button onClick={handleBulkStatusUpdate} variant="contained" disableElevation sx={{ bgcolor: '#204f4f', color: '#ffffff', fontWeight: 'bold', textTransform: 'none', px: 3, borderRadius: '8px', '&:hover': { bgcolor: '#143636', boxShadow: '0 4px 10px rgba(32,79,79,0.2)' } }}>Update Status</Button>
                </Box>
            </Dialog>

            <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar({ ...snackbar, open: false })} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}><Alert severity={snackbar.type} sx={{ width: '100%', fontWeight: 'bold' }}>{snackbar.msg}</Alert></Snackbar>
        </Box >
    );
};

export default SipReminder;